// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:14.737Z
// Property: Greenspring Apartments (ID: 6767906449166319)
// Collections: 30 amenities, 14 floorplans (live), 34 photos, 73 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166319",
  "property_external_id": "30940",
  "property_zillow_url": "https://www.zillow.com/apartments/york-pa/greenspring/5YyDY5/",
  "property_apartments_url": "https://www.apartments.com/greenspring-york-pa/4d584fk/",
  "property_google_business_url": "https://www.google.com/maps/place/Greenspring+Apartment+Homes/data=!4m2!3m1!1s0x0:0x107174cc5eb21842?sa=X&ved=2ahUKEwiv4_raoriSAxVxlokEHa4UBM0Q_BJ6BAhIEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "greenspring-apartments",
  "property_name": "Greenspring Apartments",
  "property_website_url": "https://www.livegreenspring.com/",
  "property_domain": "https://www.livegreenspring.com/",
  "property_address": "100 Bridlewood Way",
  "property_full_address": "100 Bridlewood Way, East York, PA 17402",
  "property_address_1": "100 Bridlewood Way",
  "property_address_2": null,
  "property_address_city": "York",
  "property_address_state": "PA",
  "property_address_zip_full": "17402-9160",
  "property_address_zip": "17402",
  "property_address_country": "US",
  "property_address_county": "York County",
  "property_neighborhood_address": "East York",
  "property_address_latitude": "39.9566139",
  "property_address_longitude": "-76.67621330000001",
  "property_email": "greenspring@aionmanagement.com",
  "property_phone": "(717) 755-5700",
  "property_call_tracking_phone": "844-789-2235",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Nestled in vibrant East York, PA, Greenspring Apartments offers thoughtfully designed one, two, and three-bedroom homes filled with modern comforts. Enjoy a lifestyle enriched by amenities like a sparkling swimming pool, a tennis court, and a welcoming dog park. Experience elevated living—schedule your tour today!",
  "property_long_description": "Welcome to Greenspring Apartments, your ideal sanctuary in the heart of East York, PA! Our vibrant community offers a range of thoughtfully designed floor plans, including one, two, and three-bedroom apartments, perfect for any lifestyle. Experience luxury and comfort in our renovated units, featuring modern amenities like full-size washers and dryers, air conditioning, and flexible rent payment options.\n\nAt Greenspring Apartments, we believe in creating a lifestyle full of enjoyment and relaxation. Dive into our refreshing swimming pool or unwind on the sundeck while soaking up panoramic views of our beautifully landscaped grounds. For the active residents, we offer a basketball court and tennis court to stay fit and energized. Kids can have fun at the playground, while furry friends can run free in our dedicated dog park.\n\nOur enticing clubhouse is the heart of our community, where residents can gather for events or enjoy a game in the game room. Enjoy convenience with our online resident portal, on-site management, and 24-hour emergency maintenance. With grilling stations and picnic areas, hosting gatherings with friends and family has never been easier.\n\nGreenspring Apartments is pet-friendly and offers short-term leases for ultimate flexibility. With ample on-site parking and a business center for your work-from-home needs, we've crafted a community that meets all your living requirements. \n\nDon't miss out on your dream apartment! Find your new home today—browse our availability or schedule a tour to visit our community and discover what makes Greenspring Apartments the perfect choice for you!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-dc73-716c-8ef0-a7ba4eb39a1f.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019fcdf6-dc73-716c-8ef0-a7ba4eb39a1f",
    "storage_key": "property/6767906449166319/019fcdf6-dc73-716c-8ef0-a7ba4eb39a1f.webp",
    "width": 1920,
    "height": 1278
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "276",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.27536231884058",
  "property_admin_fee": "100",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum of 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum of 2 pets per apartment, each up to 100 lb. Non‑refundable pet fee: $300 per pet. Monthly pet rent: $50 for one pet, $75 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://greenspring.loftliving.com/login",
  "property_apply_now_url": "https://www.livegreenspring.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0267-9059-7378-b6d3-e232a0104b0f.webp",
  "property_primary_logo_media": {
    "alt_text": "Greenspring Apartment Homes logo",
    "public_id": "019d0267-9059-7378-b6d3-e232a0104b0f",
    "storage_key": "property/6767906449166319/019d0267-9059-7378-b6d3-e232a0104b0f.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0267-871c-73ce-a5a8-21c167c4e615.webp",
  "property_secondary_logo_media": {
    "alt_text": "Greenspring Apartment Homes logo",
    "public_id": "019d0267-871c-73ce-a5a8-21c167c4e615",
    "storage_key": "property/6767906449166319/019d0267-871c-73ce-a5a8-21c167c4e615.webp",
    "width": 340,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0267-871c-73ce-a5a8-21c167c4e615.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Greenspring Apartment Homes logo",
    "public_id": "019d0267-871c-73ce-a5a8-21c167c4e615",
    "storage_key": "property/6767906449166319/019d0267-871c-73ce-a5a8-21c167c4e615.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0267-9059-7378-b6d3-e232a0104b0f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Greenspring Apartment Homes logo",
    "public_id": "019d0267-9059-7378-b6d3-e232a0104b0f",
    "storage_key": "property/6767906449166319/019d0267-9059-7378-b6d3-e232a0104b0f.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1000 - 1350",
  "property_sqft_min": "1000",
  "property_sqft_max": "1350",
  "property_price_range": "1359 - 2008",
  "property_price_min": "1359",
  "property_price_max": "2008",
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/GreenspringApartments/",
  "property_instagram_url": "https://www.instagram.com/greenspringapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe8521DqPyIkRQhiyXsx0cRA",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=East+York%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Greenspring Apartments",
  "property_home_romance_title": "Cherish Every Moment in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Greenspring Apartments in East York, PA, where modern living meets vibrant community life. Whether you're enjoying a sunny day by the swimming pool or hosting friends at the grilling stations, our thoughtfully designed one-, two-, and three-bedroom homes offer comfort and style. Experience the perfect blend of leisure and convenience!",
  "property_home_floorplans_blurb": "Welcome to Greenspring Apartments in East York, PA, where comfort meets convenience. Whether you seek a cozy one-bedroom retreat, a spacious two-bedroom haven, or a generous three-bedroom family space, we have it all. Browse our diverse floor plans and find your perfect apartment home tailored to your lifestyle.",
  "property_home_gallery_blurb": "Embrace a vibrant lifestyle at Greenspring Apartments in East York, PA. Choose from one, two, or three-bedroom floor plans, and enjoy amenities like a sparkling pool, dog park, and tennis court. With upgraded units and a host of resident activities, picture yourself living here, where comfort meets community!",
  "property_home_neighborhood_blurb": "Welcome to Greenspring Apartments in East York, PA, where comfortable living meets vibrant community life. Enjoy spacious floor plans—choose from one, two, or three-bedroom layouts. Revel in the charm of nearby parks, schools, and cultural attractions, including the Appell Center for the Performing Arts and York County History Center.",
  "property_home_reviews_blurb": "At Greenspring Apartments in East York, PA, our residents rave about their experiences! With exceptional customer service and a beautiful property, many find that our team, especially Wesley, goes above and beyond. As one resident shared, “the customer service has been outstanding.” Join our welcoming community today!",
  "property_neighborhood_blurb": "At Greenspring Apartments in East York, PA, enjoy a vibrant community with easy access to parks, schools, and cultural hubs. You’re moments away from WellSpan Park, York College, and the historic Appell Center for the Performing Arts. Uncover the charm of your new neighborhood and its diverse offerings!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Greenspring Apartments in East York, PA, where modern living meets leisure! Choose from one, two, or three-bedroom floor plans, and enjoy top-tier amenities like a sparkling swimming pool, dog park, and tennis courts. Embrace an active lifestyle with resident activities and relaxing outdoor spaces—all at your fingertips!",
  "property_applynow_blurb": "Welcome to Greenspring Apartments in East York, PA, where comfort meets convenience. Choose from thoughtfully designed one, two, and three-bedroom floor plans, featuring upgraded units and panoramic views. Enjoy fantastic amenities, including a sparkling swimming pool, vibrant dog park, and cozy clubhouse. Find your new home and lease online today!",
  "property_contactus_blurb": "At Greenspring Apartments in East York, PA, choose from a variety of stylish floor plans tailored to your lifestyle—one, two, or three bedrooms await you. Experience comfort and convenience in our vibrant community. Have questions? Contact our leasing team today for personalized assistance and discover your perfect home!",
  "property_faqs_blurb": "At Greenspring Apartments in East York, PA, we understand that every resident has unique needs. Whether you prefer a cozy one-bedroom or a spacious three-bedroom, our diverse floor plans cater to all lifestyles. Curious about our community? Visit our FAQs page for insights and answers to your questions!",
  "property_floorplans_blurb": "At Greenspring Apartments in East York, PA, you'll find a variety of thoughtfully designed floor plans to suit your lifestyle. With one, two, and three-bedroom options, each home offers spacious living and modern comforts. Browse our available apartment homes today and find the perfect fit for your unique needs!",
  "property_gallery_blurb": "At Greenspring Apartments in East York, PA, vibrant community life meets modern comfort. Choose from one, two, or three-bedroom floor plans, all enhanced by amenities like a sparkling pool, tennis courts, and a dog park for your furry friends. Picture yourself living here amidst inviting spaces and breathtaking views!",
  "property_interactivemap_blurb": "Nestled in East York, PA, Greenspring Apartments offers thoughtfully designed one, two, and three-bedroom layouts alongside a vibrant array of amenities. Enjoy sunny days by the pool, friendly matches on the tennis court, and relaxing picnics in the courtyard. Find your perfect home with our interactive community map!",
  "property_pets_blurb": "At Greenspring Apartments in East York, PA, your furry friends are part of the family. With a pet-friendly policy accommodating up to two pets, including dogs and cats, your home is their playground. Enjoy spacious living just moments from local parks, making every outing a joyful adventure for both you and your pets.",
  "property_referafriend_blurb": "At Greenspring Apartments in East York, PA, we celebrate community connections. Whether you prefer a cozy one-bedroom or spacious three-bedroom layout, there's a perfect home waiting for you. Great friends make great neighbors—refer a friend today and enrich our vibrant community!",
  "property_residentaccess_blurb": "Welcome to Greenspring Apartments in East York, PA, where comfort meets convenience. Our spacious one, two, and three-bedroom floor plans cater to every lifestyle. Access your resident portal to easily pay rent, schedule maintenance, and unlock a seamless living experience tailored just for you!",
  "property_reviews_blurb": "At Greenspring Apartments in East York, PA, our residents rave about the exceptional service they receive. One happy resident noted, \"Wesley went above and beyond...his knowledge and willingness to help me make the best choice.\" Experience the perfect blend of comfort, customer care, and community. Check out what our residents have to say!",
  "property_created_at": "1757006014766",
  "property_scheduletour_blurb": "Nestled in East York, PA, Greenspring Apartments offers a variety of spacious floor plans, including one, two, and three-bedroom options to suit your lifestyle. Imagine your ideal home among a welcoming community—schedule a tour today and hear firsthand why our residents love living here!",
  "property_thankyou_blurb": "Thank you for reaching out to Greenspring Apartments in East York, PA! With a variety of thoughtfully designed floor plans—ranging from one to three bedrooms—finding your perfect home is just a step away. Stay tuned; one of our dedicated team members will be in touch shortly to assist you!",
  "property_virtualtours_blurb": "Step into the vibrant lifestyle at Greenspring Apartments in East York, PA, where our thoughtfully designed one, two, and three-bedroom floor plans blend comfort and style. Ready to envision your new home? Take a virtual tour of our community and find your perfect fit today! ",
  "property_copyright": "2025 All Rights Reserved. Greenspring Apartments",
  "property_seo_title_home": "Greenspring Apartments |  Apartments in East York, PA",
  "property_seo_description_home": "Elevate your lifestyle at Greenspring Apartments! Choose from versatile floor plans, enjoy top-notch amenities, and embrace community living in East York, PA.",
  "property_seo_title_floorplans": "Floor Plans | East York, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal sanctuary at Greenspring Apartments in East York, PA! Check out our unique one, two, and three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | East York, PA Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Greenspring Apartments in East York! Enjoy our pool, dog park, sports courts, and flexible lease options. Your home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in East York, PA",
  "property_seo_description_gallery": "Discover the vibrant Greenspring Apartments in East York, PA, featuring spacious layouts, great amenities, and stunning views—your dream home!",
  "property_seo_title_virtualtours": "Virtual Tours | Greenspring Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Greenspring Apartments in East York, PA! Experience spacious one to three-bedroom homes—take a virtual tour today and envision your new life!",
  "property_seo_title_interactivemap": "Interactive Map | Greenspring Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Greenspring Apartments in East York, PA! Use our interactive map to view floor plans, pricing, and explore exceptional amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in East York, PA",
  "property_seo_description_neighborhood": "Uncover the vibrant East York neighborhood of Greenspring Apartments. Enjoy local favorites, parks, and dining just steps from your front door!",
  "property_seo_title_contact": "Contact Us | Greenspring Apartments",
  "property_seo_description_contact": "Reach out to Greenspring Apartments in East York, PA! Whether it's one, two, or three bedrooms, our leasing team is ready to help with your inquiries today!",
  "property_seo_title_faqs": "FAQs | Apartments in East York, PA",
  "property_seo_description_faqs": "Find answers to your questions at Greenspring Apartments in East York, PA. From amenities to floor plans, our FAQs page has all the details you need!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in East York, PA",
  "property_seo_description_reviews": "Join our vibrant community at Greenspring Apartments in East York! Read resident reviews and experience amenities like a pool, dog park, and more!",
  "property_seo_title_applynow": "Apply Now | Apartments in East York, PA",
  "property_seo_description_applynow": "Discover your ideal home at Greenspring Apartments in East York, PA! Enjoy great amenities, spacious layouts, and a thriving community. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | Greenspring Apartments",
  "property_seo_description_residentaccess": "Unlock convenient living at Greenspring Apartments in East York, PA. Log in to your resident portal for easy rent payments, maintenance requests, and more!",
  "property_seo_title_referafriend": "Refer A Friend | Greenspring Apartments",
  "property_seo_description_referafriend": "Refer a friend to Greenspring Apartments in East York, PA! Great friendships start here—share the joy of living in a vibrant community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Greenspring Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Greenspring Apartments in East York, PA. Book your tour today and find your perfect home in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Greenspring Apartments",
  "property_seo_description_privacy": "Your privacy matters at Greenspring Apartments in East York, PA. Dive into our policy to understand how we protect your personal information. View it now!",
  "property_seo_title_accessibility": "Website Accessibility | Greenspring Apartments",
  "property_seo_description_accessibility": "At Greenspring Apartments in East York, PA, we prioritize digital inclusion. Join our welcoming community where everyone can thrive, both online and off!",
  "property_seo_title_sitemap": "Sitemap | Greenspring Apartments",
  "property_seo_description_sitemap": "Navigate your way to the perfect home at Greenspring Apartments in East York, PA. Check out our sitemap for community amenities and floor plans!",
  "property_seo_title_thankyou": "Thank You | Greenspring Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Greenspring Apartments in East York, PA! Our team will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293656153",
  "amenities": [
    {
      "id": "custom_d806206f-e4c8-44ec-abd9-cc3cc952ea4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eec93c52-639f-4d7c-8584-daf9af6e9f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1409178-2c77-4d2e-b263-acb818ef6206",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room w/ Billiards",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_613bb0c3-6772-4c7b-af59-704f9fa47351",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59ed5f11-140d-4c0a-8b8b-9afe481f426c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0309a16f-26f5-4420-992e-d927e78b694a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_856988d0-4dbe-4ade-ba82-61bba859ca17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a53b9f42-fd69-4065-bca4-4a9b7032dcdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63a41ee8-b7b0-4434-ae2e-d8a37a0e12c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_783096bf-ec90-46b0-a930-33e994435434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26449253-12fb-4138-819a-3544ea0a121c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Individually Controlled Heating & AC",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ad16876-d501-4661-b135-a46fa5ea2655",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a8c7d621-243e-4384-8d42-623e3ea1c8b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69dd2779-9332-4834-a253-1e3031d450b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Black Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c8c02f3-cd89-438e-9055-037c36df41ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Kitchen*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4dbd22bd-0ad3-4a47-bbcc-ab6050e85562",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bfa2746-f120-4ee5-b5d7-a63ed8537687",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d8267582-7034-4b59-90b4-fe7f6be053b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Stylish Design Finishes",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_51a3f518-55e2-4a20-81c2-77ef57e8aa81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to I 83 & Route 30",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bdd4ed77-67fb-4473-b30d-31ca44ea148b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Scenic Views",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95d9560d-a798-4c71-a47e-363de012423d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Walk to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b11b37ab-cb83-4691-8f5b-8a24257ebf44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "1, 2 & 3 Bedroom Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_11e9922f-4ca1-457e-b2a4-91142ab76195",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be549ea2-9567-47b8-b462-60d49bd87be0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a99b81f1-14cf-468d-9a8a-31023d10f192",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident and Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59b6b85a-cde9-4d51-b1cf-17c787e0fff5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Area/Picnic Areas",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4e73ae1-90fa-443c-b71a-8bc288e42830",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9838d104-ce3a-4153-bd1b-233d107eeb12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3149b53-978a-4a65-a3fa-fa52d086ff9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_58173463-9b11-4bfc-90ae-d533233ba559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f1d24b7a-a4e3-40c8-8356-c61ef94a3178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-f01d-7380-a0cc-4ba09f50f5b5.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with white cabinets, black appliances, and a round dining table.",
        "public_id": "019fcdf6-f01d-7380-a0cc-4ba09f50f5b5",
        "storage_key": "property/6767906449166319/019fcdf6-f01d-7380-a0cc-4ba09f50f5b5.webp",
        "width": 1960,
        "height": 1481
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring white cabinets, gray countertops, and a round dining table by a window.",
      "link": "false",
      "alt_text": "Bright galley kitchen with white cabinets, black appliances, and a round dining table near a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/85e41eecd73999d8056b8dce7f06efb4.webp"
    },
    {
      "id": "custom_0e5efbdd-191c-421b-8ec8-6a6486aa445e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-f02c-7650-b3b0-40c7e12fe359.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and access to a bathroom.",
        "public_id": "019fcdf6-f02c-7650-b3b0-40c7e12fe359",
        "storage_key": "property/6767906449166319/019fcdf6-f02c-7650-b3b0-40c7e12fe359.webp",
        "width": 1960,
        "height": 1481
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom with neutral décor, a large bed, and an open closet with shelves.",
      "link": "false",
      "alt_text": "Bedroom in a neutral-toned apartment with a large bed, dresser, plant, and an open shelving closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/483f769bf22ed29ced6a2e58725ea48e.webp"
    },
    {
      "id": "custom_d3efd204-e269-40b4-9b78-faf6c6316d15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-f10c-707e-9f10-11a3a20eec93.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and a large sliding glass door.",
        "public_id": "019fcdf6-f10c-707e-9f10-11a3a20eec93",
        "storage_key": "property/6767906449166319/019fcdf6-f10c-707e-9f10-11a3a20eec93.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with a neutral palette, comfortable seating, and balcony access via sliding doors.",
      "link": "false",
      "alt_text": "Living room with sage-green sofa, coffee table, TV stand, plant, and sliding glass doors with vertical blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/708607788dc67dc40e3db7130894bb33.jpg"
    },
    {
      "id": "custom_534d3d46-cbeb-4a3e-a5dd-b38ce78e0f37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-f02c-7650-b3b0-3fa2b769ab06.webp",
      "image_media": {
        "alt_text": "Dining area with a table set for four and view into kitchen.",
        "public_id": "019fcdf6-f02c-7650-b3b0-3fa2b769ab06",
        "storage_key": "property/6767906449166319/019fcdf6-f02c-7650-b3b0-3fa2b769ab06.webp",
        "width": 1960,
        "height": 1481
      },
      "title": "Apartment",
      "description": "Contemporary apartment dining space with a dark wooden table, beige upholstered chairs, place settings, and simple wall art.",
      "link": "false",
      "alt_text": "Dining area with a dark wood table, beige upholstered chairs, and wall art in a modern apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/1d682da8adee87e123f37b8fb314fe0f.webp"
    },
    {
      "id": "custom_aabf706c-3b84-4c86-8683-6bccb3f29518",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-fb57-730a-98a1-f70cca2586da.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and wood-look flooring.",
        "public_id": "019fcdf6-fb57-730a-98a1-f70cca2586da",
        "storage_key": "property/6767906449166319/019fcdf6-fb57-730a-98a1-f70cca2586da.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring white cabinetry, granite countertops, a black range, and stainless steel sink. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Bright galley kitchen with white cabinets, a stainless steel stove and sink, and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/3149084bebb442d8ef412ce1dcb274fd.webp"
    },
    {
      "id": "custom_5e8f6f12-6a98-4a01-8ffa-88b2fefa53e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-fc3f-737e-b942-fb680993a2f9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel sink, dishwasher, and black appliances.",
        "public_id": "019fcdf6-fc3f-737e-b942-fb680993a2f9",
        "storage_key": "property/6767906449166319/019fcdf6-fc3f-737e-b942-fb680993a2f9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white cabinetry, grey countertops, stainless steel appliances, and wood-look flooring.",
      "link": "false",
      "alt_text": "Kitchen with white upper and lower cabinets, grey speckled countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/93254f88025bb81c8eed66139fd69a78-9531a499.webp"
    },
    {
      "id": "custom_bb38bb9c-4603-4e00-8fa2-3603d419e42b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-fc4e-74ae-8e3c-ad07eebd2274.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, TV, and closet.",
        "public_id": "019fcdf6-fc4e-74ae-8e3c-ad07eebd2274",
        "storage_key": "property/6767906449166319/019fcdf6-fc4e-74ae-8e3c-ad07eebd2274.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bedroom with neutral tones, plush bedding, a dresser, and a wall-mounted TV.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, beige comforter, dresser with a mounted TV, and an open closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/269aa6d540f3834c35572ea153c3d59f.webp"
    },
    {
      "id": "custom_e1376025-abeb-4dc2-a563-1019fd0deb54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf6-fcd6-7751-9fd9-8f273bcb1674.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, closet, and en-suite bathroom.",
        "public_id": "019fcdf6-fcd6-7751-9fd9-8f273bcb1674",
        "storage_key": "property/6767906449166319/019fcdf6-fcd6-7751-9fd9-8f273bcb1674.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom with neutral decor, a large bed, twin nightstands, and an en-suite bathroom and closet accessible from the room.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, two nightstands, and open doors to a closet and bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/e1d666b1b2896890a8d8564f8375b1bc.webp"
    },
    {
      "id": "custom_1f9ca5b1-b3ff-4aba-bb0d-9de368222b2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-06a2-7488-a325-eebe17ab5999.webp",
      "image_media": {
        "alt_text": "Dining area with a white oval table, four chairs, and a ceiling fan.",
        "public_id": "019fcdf7-06a2-7488-a325-eebe17ab5999",
        "storage_key": "property/6767906449166319/019fcdf7-06a2-7488-a325-eebe17ab5999.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "A bright dining area features a white oval table with four chairs, a ceiling fan, and a view into a clean white kitchen.",
      "link": "false",
      "alt_text": "Dining area in an apartment with a round table, chairs, a sideboard, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/766a4ab43d71dd00a0fb412cdb57caee.jpg"
    },
    {
      "id": "custom_f6037f36-05e5-48e9-b798-401e284ae597",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-06a0-7717-baad-ac30eb6572f1.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sofa, armchair, coffee table, and dining set.",
        "public_id": "019fcdf7-06a0-7717-baad-ac30eb6572f1",
        "storage_key": "property/6767906449166319/019fcdf7-06a0-7717-baad-ac30eb6572f1.webp",
        "width": 2000,
        "height": 1511
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with neutral furnishings, a TV, dining nook, and a tall bookshelf.",
      "link": "false",
      "alt_text": "Living room with beige sofas, a coffee table, TV stand, dining table in the background, and a bookshelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/0ceb5da90ea2a3603ac6b04425dd1ca2.webp"
    },
    {
      "id": "custom_7f88a9fc-52ab-4618-bb68-cb56dbdb4336",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-087b-7240-b3d7-fbeb424ddc3d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and stacked washer/dryer.",
        "public_id": "019fcdf7-087b-7240-b3d7-fbeb424ddc3d",
        "storage_key": "property/6767906449166319/019fcdf7-087b-7240-b3d7-fbeb424ddc3d.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white cabinetry, quartz counters, subway tile backsplash, and in-unit laundry.",
      "link": "false",
      "alt_text": "Bright kitchen with white cabinets, stainless-steel appliances, and a stacked washer/dryer in a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/0e1bfeb237268d405a5617f73174fc9d.jpg"
    },
    {
      "id": "custom_7a3b08a0-133d-463a-9458-9534248522ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-08a1-7229-9d7f-6c9032156f68.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and mounted TV.",
        "public_id": "019fcdf7-08a1-7229-9d7f-6c9032156f68",
        "storage_key": "property/6767906449166319/019fcdf7-08a1-7229-9d7f-6c9032156f68.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, a modern dresser with a mounted television, and large windows offering natural light.",
      "link": "false",
      "alt_text": "Bedroom with a large window, beige bedding, TV on the wall, and a decorative dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/fe892735d5b96c20be538f42a5910856.webp"
    },
    {
      "id": "custom_d604d1e9-5115-4ad6-a42f-8d108df7cea1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-136b-712c-a84c-8d8befa3c4ec.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and window overlooking a green lawn.",
        "public_id": "019fcdf7-136b-712c-a84c-8d8befa3c4ec",
        "storage_key": "property/6767906449166319/019fcdf7-136b-712c-a84c-8d8befa3c4ec.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Modern apartment bedroom with neutral tones, an upholstered headboard, and geometric wall art.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a large bed, nightstand, dresser, and abstract wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/074a43300255e53346c42cc8cf1fdd41.webp"
    },
    {
      "id": "custom_99d8be8f-5340-4998-96e7-b385ef12063f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-1581-774f-af7b-fcb3d78bf91b.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, and shower",
        "public_id": "019fcdf7-1581-774f-af7b-fcb3d78bf91b",
        "storage_key": "property/6767906449166319/019fcdf7-1581-774f-af7b-fcb3d78bf91b.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Bright, modern bathroom with white cabinetry, marble countertop, and sleek black fixtures.",
      "link": "false",
      "alt_text": "Small contemporary bathroom with white vanity, black faucet, mirror cabinet, black towel ring, and a tub/shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/4d4a2d5bf7549d7f19543d42bf14180d.jpg"
    },
    {
      "id": "custom_048e5fde-1213-4997-9d04-5c18fc43306b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-1664-72fc-9004-d28564b50889.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with sink, black faucet, and marble countertop. Adjacent to toilet and bathtub with shower curtain.",
        "public_id": "019fcdf7-1664-72fc-9004-d28564b50889",
        "storage_key": "property/6767906449166319/019fcdf7-1664-72fc-9004-d28564b50889.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with white marble-style countertop, black fixtures, mirrored cabinets, and a tub/shower combo.",
      "link": "false",
      "alt_text": "Bathroom with white vanity, black faucet, mirrored cabinets, toilet, and tub with curved shower rod.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/6e69408efd6116182e028b1066bdafaa.jpg"
    },
    {
      "id": "custom_d49a92ef-1db7-45f4-8e61-815ab92e1e38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-15fc-754a-be67-54c6415393b3.webp",
      "image_media": {
        "alt_text": "Walk-in closet with built-in shelving and hanging rods.",
        "public_id": "019fcdf7-15fc-754a-be67-54c6415393b3",
        "storage_key": "property/6767906449166319/019fcdf7-15fc-754a-be67-54c6415393b3.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Bright walk-in closet with built-in white shelving, hanging rods along both sides, and neutral carpeting.",
      "link": "false",
      "alt_text": "Interior of a walk-in closet with white shelving and hanging rods.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/3ae6993f6ac3effeed98d5caf438dd37.webp"
    },
    {
      "id": "custom_b98f01e4-6642-4889-b535-fb10d3a17eb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-20bb-73ab-b908-106edf1c4eb2.webp",
      "image_media": {
        "alt_text": "Balcony view with brick wall and green landscape",
        "public_id": "019fcdf7-20bb-73ab-b908-106edf1c4eb2",
        "storage_key": "property/6767906449166319/019fcdf7-20bb-73ab-b908-106edf1c4eb2.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Enjoy your morning coffee on this private balcony, featuring a brick exterior wall and scenic views of the surrounding greenery and community.",
      "link": "false",
      "alt_text": "Balcony with brick wall and curved black railing, overlooking a green lawn and distant houses.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/d63d65ce10f3bfcdd01a557695af1cf8.jpg"
    },
    {
      "id": "custom_e15daaf8-1695-42d1-99a8-47c4f1a81d46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-21b7-70ee-96e5-f81232df1c35.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdf7-21b7-70ee-96e5-f81232df1c35",
        "storage_key": "property/6767906449166319/019fcdf7-21b7-70ee-96e5-f81232df1c35.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery.",
      "link": "false",
      "alt_text": "Outdoor community pool with lounge chairs, umbrellas, and a fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/a89453532e5998162f91a5d85f8b00a9.jpg"
    },
    {
      "id": "custom_eb631566-ff31-463d-890b-a9155809ea68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-27cf-75a9-b8ea-b2f703994032.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with tables and umbrellas",
        "public_id": "019fcdf7-27cf-75a9-b8ea-b2f703994032",
        "storage_key": "property/6767906449166319/019fcdf7-27cf-75a9-b8ea-b2f703994032.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Sunny community pool area at the apartment complex with lounge chairs and tables under umbrellas.",
      "link": "false",
      "alt_text": "Outdoor pool area with a circular pool, black metal fence, and seating under umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/83f692b6c200cdf09c79ec0d89d136a0.jpg"
    },
    {
      "id": "custom_97b2de1e-4d3e-4dd2-b6c4-d2ccba9fe803",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-2ca0-774c-af78-7190faeb5937.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and pet waste station.",
        "public_id": "019fcdf7-2ca0-774c-af78-7190faeb5937",
        "storage_key": "property/6767906449166319/019fcdf7-2ca0-774c-af78-7190faeb5937.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Community",
      "description": "Bright community lawn with a small green play ramp and tunnel, fenced along a hedge, adjacent to brick apartment buildings.",
      "link": "false",
      "alt_text": "Open grassy community yard with a small green play ramp and tunnel, fenced, beside brick apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/43376c1905e7b5622dae3e8b0a28bd08.webp"
    },
    {
      "id": "custom_a15a8dad-dcd5-42bd-826b-8f6cfd50a50c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-2f7b-7356-983e-4ec52311e41e.webp",
      "image_media": {
        "alt_text": "Lobby with a large sectional sofa, coffee table, fireplace, and a bar area.",
        "public_id": "019fcdf7-2f7b-7356-983e-4ec52311e41e",
        "storage_key": "property/6767906449166319/019fcdf7-2f7b-7356-983e-4ec52311e41e.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Spacious community lounge with modern seating, fireplace, TV, bookshelves, and a bar-height counter for residents.",
      "link": "false",
      "alt_text": "Indoor community lounge with sofa, chairs, a fireplace, TV, bookshelf, and a bar-height counter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/40a45753edff6f242848999a9821f144.jpg"
    },
    {
      "id": "custom_e331909e-e57c-4333-b036-a176d54fdca8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-3311-751c-85d2-242d642e6a19.webp",
      "image_media": {
        "alt_text": "Community room with a pool table, fireplace, seating, and view of the outdoor pool.",
        "public_id": "019fcdf7-3311-751c-85d2-242d642e6a19",
        "storage_key": "property/6767906449166319/019fcdf7-3311-751c-85d2-242d642e6a19.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation in our community's game room, complete with a pool table, cozy seating area, and a fireplace. Step outside to enjoy the sparkling outdoor pool.",
      "link": "false",
      "alt_text": "Spacious community game room with a pool table, seating area, and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/2550c6a939a700440012565ebbb4bbd2.jpg"
    },
    {
      "id": "custom_118ef2d3-e844-4fdf-8c9a-1512c9df0213",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-3820-7697-bb38-a6de5287df7d.webp",
      "image_media": {
        "alt_text": "Living room with large sliding glass doors and a balcony overlooking a green landscape.",
        "public_id": "019fcdf7-3820-7697-bb38-a6de5287df7d",
        "storage_key": "property/6767906449166319/019fcdf7-3820-7697-bb38-a6de5287df7d.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with stylish seating, a wall-mounted TV, and balcony access.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a blue sofa, mustard chair, coffee table, TV on the wall, and a sliding balcony door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/bc78fd7e241618d3f3d1805ebec8557a.webp"
    },
    {
      "id": "custom_8351977a-3a34-4371-ad55-8074ba4e6915",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-3a5f-766f-abb4-567b18d74089.webp",
      "image_media": {
        "alt_text": "A business center with two desks, computers, and a printer.",
        "public_id": "019fcdf7-3a5f-766f-abb4-567b18d74089",
        "storage_key": "property/6767906449166319/019fcdf7-3a5f-766f-abb4-567b18d74089.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Community",
      "description": "Leasing center workstation in a common area with dual monitors, a printer, and seating.",
      "link": "false",
      "alt_text": "Leasing center workstation with two wall-mounted monitors, a printer, and white chairs in a beige room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/116277cb04f9dbb6179c7465c433cbdd.webp"
    },
    {
      "id": "custom_3a100505-7441-4cc4-b2af-74f59b97c2e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-3eb6-7319-b8b8-397b60901d34.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with trees in the background.",
        "public_id": "019fcdf7-3eb6-7319-b8b8-397b60901d34",
        "storage_key": "property/6767906449166319/019fcdf7-3eb6-7319-b8b8-397b60901d34.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Community",
      "description": "Outdoor basketball court at the property’s amenity area, ideal for resident recreation and community fitness.",
      "link": "false",
      "alt_text": "Outdoor basketball court with hoops, surrounded by trees and a chain-link fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/3bab7b7c31a88acfb467ec7d5861e643.webp"
    },
    {
      "id": "custom_66464392-5dc6-4b7d-9c12-bd66d997ba6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-4384-7018-9e38-9310acb6316d.webp",
      "image_media": {
        "alt_text": "Tennis court and basketball court with playground and apartment buildings in the background",
        "public_id": "019fcdf7-4384-7018-9e38-9310acb6316d",
        "storage_key": "property/6767906449166319/019fcdf7-4384-7018-9e38-9310acb6316d.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our tennis and basketball courts, or let the kids play on the playground. Surrounded by lush greenery and apartment buildings, this is the perfect community amenity.",
      "link": "false",
      "alt_text": "Blue outdoor multi-use court with white lines, fenced, and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/6a217e1d34883a379c29c7d3fa07819f.jpg"
    },
    {
      "id": "custom_2dd729bb-bf69-481e-9925-7d98b1941f73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-43cc-7451-9a05-9514ee333dc5.webp",
      "image_media": {
        "alt_text": "Playground with slides, swings, and a basketball court in the background.",
        "public_id": "019fcdf7-43cc-7451-9a05-9514ee333dc5",
        "storage_key": "property/6767906449166319/019fcdf7-43cc-7451-9a05-9514ee333dc5.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Bright orange playground structure at a family-friendly apartment community, with a pool and courts in the background.",
      "link": "false",
      "alt_text": "Orange playground slide at a community amenity area with a pool and sports court visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/a25c6ea0e23ce6c1eda0c305a555e1be.jpg"
    },
    {
      "id": "custom_66662383-a5b1-4588-841f-3686b65ba102",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-4594-773f-b5d6-c75ad02c92fa.webp",
      "image_media": {
        "alt_text": "Playground with swings and slides next to apartment buildings.",
        "public_id": "019fcdf7-4594-773f-b5d6-c75ad02c92fa",
        "storage_key": "property/6767906449166319/019fcdf7-4594-773f-b5d6-c75ad02c92fa.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Outdoor community playground with swings and a red slide, surrounded by green lawns and apartment buildings.",
      "link": "false",
      "alt_text": "Playground with swings and a bright red slide in a residential community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/16cce8311539306c6e22d501d1f65f6e.jpg"
    },
    {
      "id": "custom_7f1e04a9-7ac8-4ffe-9023-d91dd3e886f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-4ad6-7379-a887-d5b3d912d18c.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including a tunnel and ramp.",
        "public_id": "019fcdf7-4ad6-7379-a887-d5b3d912d18c",
        "storage_key": "property/6767906449166319/019fcdf7-4ad6-7379-a887-d5b3d912d18c.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Our community features a dedicated dog park with agility equipment for your furry friends to enjoy.",
      "link": "false",
      "alt_text": "Playground on a grassy lawn with a brick apartment building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/d08fc8e3d0e4a0aa0180703e561fd1a6.jpg"
    },
    {
      "id": "custom_97dc9b1e-f342-425f-810c-64c77085d87c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-4efe-765e-8d3b-c6ee924aa4c1.webp",
      "image_media": {
        "alt_text": "Greenspring package lockers",
        "public_id": "019fcdf7-4efe-765e-8d3b-c6ee924aa4c1",
        "storage_key": "property/6767906449166319/019fcdf7-4efe-765e-8d3b-c6ee924aa4c1.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Exterior view of communal storage lockers at Greenspring, showing a long row of blue units with a brick building and trees behind.",
      "link": "false",
      "alt_text": "Row of blue storage lockers on a concrete pad with trees and a brick building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/00b0b4ce707d92860d3620dde66a28d2.jpg"
    },
    {
      "id": "custom_dfc3121c-dcd3-408e-9855-a96d0775bab2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-50e9-772e-84e0-56eb28175e0f.webp",
      "image_media": {
        "alt_text": "Outdoor grill and trash can in a fenced area with a basketball court and apartment buildings in the background.",
        "public_id": "019fcdf7-50e9-772e-84e0-56eb28175e0f",
        "storage_key": "property/6767906449166319/019fcdf7-50e9-772e-84e0-56eb28175e0f.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Outdoor community grilling area at the property with a stainless steel BBQ grill and storage cabinet.",
      "link": "false",
      "alt_text": "Outdoor stainless steel BBQ grill on a concrete pad with a storage cabinet, fenced yard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/3f2d4d9729270a401e4cd486cfda4ebd.jpg"
    },
    {
      "id": "custom_f1726704-30df-40ea-b60c-d760aac99647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-518b-74af-9715-bf4c5851568c.webp",
      "image_media": {
        "alt_text": "Exterior of the Greenspring Apartment Homes leasing office with a paved walkway and landscaping.",
        "public_id": "019fcdf7-518b-74af-9715-bf4c5851568c",
        "storage_key": "property/6767906449166319/019fcdf7-518b-74af-9715-bf4c5851568c.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Exterior view of the community leasing office with landscaped grounds and welcoming entrance.",
      "link": "false",
      "alt_text": "Brick leasing office entrance with glass door, flanked by shrubs and a tree.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/c6b44b0cc0315750aa211826f39ed304.jpg"
    },
    {
      "id": "custom_ec3b96d9-a083-46b1-90ca-ce3fd5bbc231",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-56cc-7704-95fd-208869092892.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a winding road and parking lot.",
        "public_id": "019fcdf7-56cc-7704-95fd-208869092892",
        "storage_key": "property/6767906449166319/019fcdf7-56cc-7704-95fd-208869092892.webp",
        "width": 636,
        "height": 480
      },
      "title": "Community",
      "description": "Exterior shot of a multi-building apartment community with green space and a curved road.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment complex with curved driveway and manicured lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/99ceb160f5d77dcf5c6aaeecfcc6a227.jpg"
    },
    {
      "id": "custom_0581d5a7-a824-4bf5-9249-ad4bc5568a2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-5a75-738e-a3c3-a4132aa17c35.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities including a pool and sports courts.",
        "public_id": "019fcdf7-5a75-738e-a3c3-a4132aa17c35",
        "storage_key": "property/6767906449166319/019fcdf7-5a75-738e-a3c3-a4132aa17c35.webp",
        "width": 715,
        "height": 540
      },
      "title": "Community",
      "description": "Bird's-eye view of a multifamily community with apartment buildings, winding streets, green spaces, and a central pool.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily community with buildings, roads, green spaces, and a swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f44d8bc/dms3rep/multi/5767906449162442/6767906449166319/ee250fdc235f3d6ceb3635a40657bec2.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e67aa669-f11e-4cbc-a92e-872e022c8ba5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Tokyo Diner",
      "poi_type": "Restaurants",
      "poi_address": "2300 E Market St #2858, East York, PA 17402, USA",
      "poi_short_description": "Japanese BYOB option with lunch specials, a variety of sushi rolls & hibachi chefs grilling entrees.",
      "poi_long_description": "Japanese BYOB option with lunch specials, a variety of sushi rolls & hibachi chefs grilling entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-e1be-737f-b41a-1b4b9c55d8b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-e1be-737f-b41a-1b4b9c55d8b3",
        "storage_key": "property/6767906449166319/019fd80c-e1be-737f-b41a-1b4b9c55d8b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tokyodinereastyork.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5063089596488189683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tokyo-diner",
      "poi_latitude": "39.9732521",
      "poi_longitude": "-76.6812853",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 717-755-9638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXf6fhuPyIkR84anoCm1Q0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43f94217-32b9-4767-ae5a-89d3e8d5e08f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Village Green Family Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2300 E Market St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-e10e-7008-8a6f-517fd5b8b55a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-e10e-7008-8a6f-517fd5b8b55a",
        "storage_key": "property/6767906449166319/019fd80c-e10e-7008-8a6f-517fd5b8b55a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7080998504833987832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-green-family-restaurant",
      "poi_latitude": "39.9726975",
      "poi_longitude": "-76.6811003",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 717-755-9839",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXf6fhuPyIkR-LSzl5_CRGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06554d05-34a3-44e4-bf9c-e9c4c9961708",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "2801 E Market St, York, PA 17402, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-e10e-7008-8a6f-55e0378c49d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-e10e-7008-8a6f-55e0378c49d0",
        "storage_key": "property/6767906449166319/019fd80c-e10e-7008-8a6f-55e0378c49d0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/pa/york/2801-e-market-st?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=600769&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=17319124842693432842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "39.976031",
      "poi_longitude": "-76.67286299999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 717-751-0202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d126-77dc-9387-6385ee997677.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d126-77dc-9387-6385ee997677",
        "storage_key": "property/6767906449166319/019d0265-d126-77dc-9387-6385ee997677.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJf_fxGhCPyIkRCpZipUjkWfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad74d553-af80-42f9-ab28-e62d5e91451e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2801 E Market St, York, PA 17402, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-6e0f-7375-87cd-7536f1806b25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf7-6e0f-7375-87cd-7536f1806b25",
        "storage_key": "property/6767906449166319/019fcdf7-6e0f-7375-87cd-7536f1806b25.webp",
        "width": 1280,
        "height": 655
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/pa/east-york?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=7297075510003785350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "39.9762456",
      "poi_longitude": "-76.6701308",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-757-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4WbgA6PyIkRhl76yINrRGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_46230741-0efd-411a-b742-2c69287ed76d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "The Captain Krab",
      "poi_type": "Restaurants",
      "poi_address": "2801 E Market St suite g7, York, PA 17402, USA",
      "poi_short_description": "Casual eatery offering fried chicken wings, Cajun-inspired seafood boil meals and sushi, plus Cajun snacks and fried shrimp.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-e846-7748-b029-2bf915b27e46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-e846-7748-b029-2bf915b27e46",
        "storage_key": "property/6767906449166319/019fd80c-e846-7748-b029-2bf915b27e46.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.thecaptainkrabyorkpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18355235586953137853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-captain-krab",
      "poi_latitude": "39.9796356",
      "poi_longitude": "-76.67237589999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-900-6421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQPPVtuPyIkRvU7zIITluv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5562dab5-16fa-4171-a9b2-fc6cc310aaba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "York Marketplace, 2521 E Market St, East York, PA 17402, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-ea0c-759b-8051-964fe4b09355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-ea0c-759b-8051-964fe4b09355",
        "storage_key": "property/6767906449166319/019fd80c-ea0c-759b-8051-964fe4b09355.webp",
        "width": 1210,
        "height": 1280
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/15883/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050232034809938092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "39.97636",
      "poi_longitude": "-76.67672999999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-757-0654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d126-77dc-9387-6385ee997677.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d126-77dc-9387-6385ee997677",
        "storage_key": "property/6767906449166319/019d0265-d126-77dc-9387-6385ee997677.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJg_8QSgWPyIkRrADVHLOXnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0823fd20-0b23-4f5b-b064-b542a05628fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "2270 E Market St, East York, PA 17402, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-eadf-74e3-911f-cc3456a036c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-eadf-74e3-911f-cc3456a036c3",
        "storage_key": "property/6767906449166319/019fd80c-eadf-74e3-911f-cc3456a036c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/pa/east-york/2270-e-market-st/353397?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=353397&y_source=1_MTIxMTE1MDEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16737357361117312369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "39.9735706",
      "poi_longitude": "-76.68186949999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 717-747-1025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d126-77dc-9387-6385ee997677.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d126-77dc-9387-6385ee997677",
        "storage_key": "property/6767906449166319/019d0265-d126-77dc-9387-6385ee997677.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJiQPWnByPyIkRcbUqdNcJR-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b5c21136-3c8a-4458-b904-a29d16609ffc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Parma Pizza and Grill",
      "poi_type": "Restaurants",
      "poi_address": "1041 Haines Rd, York, PA 17402, USA",
      "poi_short_description": "Casual pizzeria with a pool table and foosball, plus burgers and salads, among other choices.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-eff0-777d-a43d-51c87c2b2775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-eff0-777d-a43d-51c87c2b2775",
        "storage_key": "property/6767906449166319/019fd80c-eff0-777d-a43d-51c87c2b2775.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://parmapizzaandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3537676710127928264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parma-pizza-and-grill",
      "poi_latitude": "39.9603531",
      "poi_longitude": "-76.6807571",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 717-755-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQmd5COPyIkRyANZdTlaGDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e1dff4b-02aa-4a69-8bca-440fdf5e981d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Memory Lane Pizza",
      "poi_type": "Restaurants",
      "poi_address": "162 Memory Ln, East York, PA 17402, USA",
      "poi_short_description": "Founded in 1958, this local pizza chain also offers casual Italian sandwiches & entrees.",
      "poi_long_description": "Founded in 1958, this local pizza chain also offers casual Italian sandwiches & entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-fb00-76bb-8bfd-37e3fa961892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-fb00-76bb-8bfd-37e3fa961892",
        "storage_key": "property/6767906449166319/019fd80c-fb00-76bb-8bfd-37e3fa961892.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.memorylanepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623779433614641792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memory-lane-pizza",
      "poi_latitude": "39.97666100000001",
      "poi_longitude": "-76.68101399999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-755-6362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQmpmASPyIkRgIoXOM_1T6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_68978f6c-bb9a-4606-8f09-2f04024416fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Roburrito's",
      "poi_type": "Restaurants",
      "poi_address": "201 Memory Ln, York, PA 17402, USA",
      "poi_short_description": "A simple menu of made-to-order burritos along with quesadillas & sides offered in an informal space.",
      "poi_long_description": "A simple menu of made-to-order burritos along with quesadillas & sides offered in an informal space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-f194-732c-94ba-6abc53cce880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-f194-732c-94ba-6abc53cce880",
        "storage_key": "property/6767906449166319/019fd80c-f194-732c-94ba-6abc53cce880.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://roburritos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16617177561649995408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roburritos",
      "poi_latitude": "39.9774341",
      "poi_longitude": "-76.6806761",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 717-650-6066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Vs1hASPyIkRkF69Y_MSnOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d525ebc1-e84b-42a4-90ba-e5fc3153c471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Wingstop",
      "poi_type": "Restaurants",
      "poi_address": "2474 E Market St, York, PA 17402, USA",
      "poi_short_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_long_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-f6b2-7346-a734-6d228f303b49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-f6b2-7346-a734-6d228f303b49",
        "storage_key": "property/6767906449166319/019fd80c-f6b2-7346-a734-6d228f303b49.webp",
        "width": 882,
        "height": 496
      },
      "poi_business_url": "https://www.wingstop.com/location/wingstop-2259-york-pa-17402/menu?y_source=1_NjIxOTMzMjgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5401711815645049728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wingstop",
      "poi_latitude": "39.9736462",
      "poi_longitude": "-76.6776682",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 717-699-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq45EI42PyIkRgLON3ka89ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0d8fc904-fbba-4cf4-9599-27fb90cfa9ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Taco Bell",
      "poi_type": "Restaurants",
      "poi_address": "2411 E Market St, York, PA 17402, USA",
      "poi_short_description": "Fast-food chain serving Mexican-inspired fare such as tacos, quesadillas & nachos.",
      "poi_long_description": "Fast-food chain serving Mexican-inspired fare such as tacos, quesadillas & nachos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-f8d7-7652-bc31-445742e918ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-f8d7-7652-bc31-445742e918ff",
        "storage_key": "property/6767906449166319/019fd80c-f8d7-7652-bc31-445742e918ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.tacobell.com/pa/york/2411-e-market-st.html?utm_source=yext&utm_campaign=googlelistings&utm_medium=referral&utm_term=024414&utm_content=website&y_source=1_NjE0NDkzMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15700314276934274987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taco-bell",
      "poi_latitude": "39.9746927",
      "poi_longitude": "-76.6796291",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-755-3961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX6MMxuPyIkRq0-pqqa44tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_be0f8c66-7ebc-4bc5-9004-ae6c75bcfa8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Arooga's",
      "poi_type": "Restaurants",
      "poi_address": "1211 Haines Rd, York, PA 17402, USA",
      "poi_short_description": "Sports bar & grill featuring a variety of classic bar eats, plus beer & signature cocktails.",
      "poi_long_description": "Sports bar & grill featuring a variety of classic bar eats, plus beer & signature cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80c-fde6-77e9-bde0-8d33c4fa4849.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80c-fde6-77e9-bde0-8d33c4fa4849",
        "storage_key": "property/6767906449166319/019fd80c-fde6-77e9-bde0-8d33c4fa4849.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "https://www.aroogas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1826452502166856661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aroogas",
      "poi_latitude": "39.95698549999999",
      "poi_longitude": "-76.6820975",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 717-718-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e1-71a7-992b-0e2c2c6b17e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e1-71a7-992b-0e2c2c6b17e9",
        "storage_key": "property/6767906449166319/019d0265-d0e1-71a7-992b-0e2c2c6b17e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxUZcSaPyIkR1WPHrt_cWBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b58a9257-4638-471b-8214-fb3e2cb03108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "236 Pauline Dr, York, PA 17402, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-62c7-7356-97e4-5321f2b5b1aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-62c7-7356-97e4-5321f2b5b1aa",
        "storage_key": "property/6767906449166319/019d0265-62c7-7356-97e4-5321f2b5b1aa.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/pa/york/199/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=246933424920968409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "39.9340341",
      "poi_longitude": "-76.68524889999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 717-741-0938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_rgtNmIyIkR2byVQ6RIbQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1f43e12d-e6ba-478b-9183-fddd8216361f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "1500 Mt Zion Rd, York, PA 17402, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-6439-71ba-9234-83c9a6610a47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-6439-71ba-9234-83c9a6610a47",
        "storage_key": "property/6767906449166319/019d0265-6439-71ba-9234-83c9a6610a47.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/pa/york/york-491?store_id=491&store_type=franchise&utm_campaign=local-business-listing&utm_content=website-link&utm_medium=organic-seach&utm_source=google-business-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535657844264821427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "39.9898872",
      "poi_longitude": "-76.67172649999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-885-9674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e3-7388-8041-573937c845e5",
        "storage_key": "property/6767906449166319/019d0265-d0e3-7388-8041-573937c845e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-T-96OPyIkRs2Ku45W_dHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ef3324a-23d5-409f-95a7-4031b62e4f1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping",
      "poi_address": "2415 E Market St, York, PA 17402, USA",
      "poi_short_description": "Chain supermarket offering everyday groceries, produce, and prepared foods, plus a deli and sushi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf7-d7a2-7111-a3b4-966653d6580f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf7-d7a2-7111-a3b4-966653d6580f",
        "storage_key": "property/6767906449166319/019fcdf7-d7a2-7111-a3b4-966653d6580f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.giantfoodstores.com/pa/york/2415-east-market-st?y_source=1_NDE5NTUxNy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2826058788674595825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "39.97525170000001",
      "poi_longitude": "-76.6788076",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 717-755-0991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e2-73a7-97b0-2978e9d3ff92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e2-73a7-97b0-2978e9d3ff92",
        "storage_key": "property/6767906449166319/019d0265-d0e2-73a7-97b0-2978e9d3ff92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDfcWOxuPyIkR8etRxX4tOCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_949878c8-c60f-49d7-b786-9d68e8af83fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Weis Markets",
      "poi_type": "Shopping",
      "poi_address": "2400 E Market St, York, PA 17402, USA",
      "poi_short_description": "Grocery store chain offering a wide selection of organic products, prepared foods, and meat, plus a salad bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-00f4-74e5-84f8-4cbdff4c2d1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-00f4-74e5-84f8-4cbdff4c2d1f",
        "storage_key": "property/6767906449166319/019fd80d-00f4-74e5-84f8-4cbdff4c2d1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.weismarkets.com/stores#/4395",
      "poi_directions_map_url": "https://maps.google.com/?cid=14307498524656857286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weis-markets",
      "poi_latitude": "39.9737915",
      "poi_longitude": "-76.67935039999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 717-757-5942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e2-73a7-97b0-2978e9d3ff92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e2-73a7-97b0-2978e9d3ff92",
        "storage_key": "property/6767906449166319/019d0265-d0e2-73a7-97b0-2978e9d3ff92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC0ysGxuPyIkRxvCYkhpyjsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6aee68d5-8268-4330-9e6f-46b175dd75ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "280 N Northern Way, York, PA 17402, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-0384-70d1-be01-c842f2115d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-0384-70d1-be01-c842f2115d47",
        "storage_key": "property/6767906449166319/019fd80d-0384-70d1-be01-c842f2115d47.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.aldi.us/pa/york/280-northern-way?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=13270677110623608522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.9775373",
      "poi_longitude": "-76.6754602",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e2-73a7-97b0-2978e9d3ff92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e2-73a7-97b0-2978e9d3ff92",
        "storage_key": "property/6767906449166319/019d0265-d0e2-73a7-97b0-2978e9d3ff92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Skjfw-PyIkRyp6gY4XqKrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63e6661e-0d41-497d-9af3-63f2258ac87d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping",
      "poi_address": "2801 E Market St Bldg B, York, PA 17402, USA",
      "poi_short_description": "Retailer offering a range of merchandise including clothing, electronics, home goods, and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-051a-7569-b36e-32c83cb5851c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-051a-7569-b36e-32c83cb5851c",
        "storage_key": "property/6767906449166319/019fd80d-051a-7569-b36e-32c83cb5851c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1529-york-pa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2139011681355998499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.97769539999999",
      "poi_longitude": "-76.6717147",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 717-755-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmSZ42w6PyIkRI6WijcpLrx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f88376f9-bc9f-41f6-a80f-55fe5a0a711f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping",
      "poi_address": "2610 Pleasant Valley Rd, York, PA 17402, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-0916-7023-826b-2030a3d0af23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-0916-7023-826b-2030a3d0af23",
        "storage_key": "property/6767906449166319/019fd80d-0916-7023-826b-2030a3d0af23.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/york-galleria/1221",
      "poi_directions_map_url": "https://maps.google.com/?cid=10856664223674622472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "39.9871068",
      "poi_longitude": "-76.6803853",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 717-755-2759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkewimKmPyIkRCGLRIZeeqpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_46e62c5f-496a-4643-9135-d730044a2e03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "820 Edgewood Rd, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-0b07-7260-8698-1ee10596adca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-0b07-7260-8698-1ee10596adca",
        "storage_key": "property/6767906449166319/019fd80d-0b07-7260-8698-1ee10596adca.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/york-pa-pharmacies/820-edgewood-road-york-pa-17402/storeid=4215?WT.mc_id=LS_GOOGLE_RX_4215",
      "poi_directions_map_url": "https://maps.google.com/?cid=6870713407788840889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.9604563",
      "poi_longitude": "-76.6611448",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 717-757-6252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d6eb-711a-bc33-8620cc8f2e08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d6eb-711a-bc33-8620cc8f2e08",
        "storage_key": "property/6767906449166319/019d0265-d6eb-711a-bc33-8620cc8f2e08.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXnaqUGPyIkRuXfEGHGtWV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eadad82a-012f-40ea-91d6-bdbd06bb099d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York Galleria",
      "poi_type": "Shopping",
      "poi_address": "2899 Whiteford Rd, York, PA 17402, USA",
      "poi_short_description": "Glass-roofed, bi-level mall housing familiar stores, a gym & casual dining options.",
      "poi_long_description": "Glass-roofed, bi-level mall housing familiar stores, a gym & casual dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-0b32-7039-92d7-5cb148969326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-0b32-7039-92d7-5cb148969326",
        "storage_key": "property/6767906449166319/019fd80d-0b32-7039-92d7-5cb148969326.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.yorkgalleria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3683406123084729339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-galleria",
      "poi_latitude": "39.9892226",
      "poi_longitude": "-76.67561769999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 717-840-1322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA9X-DaaPyIkR-8v2eVoWHjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3eca55db-4ecb-4331-a9a6-52cd6cc5d03d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Gabe's",
      "poi_type": "Shopping",
      "poi_address": "1226 Greensprings Dr, York, PA 17402, USA",
      "poi_short_description": "Discount chain stocking brand-name apparel, shoes & accessories for adults & kids, plus housewares.",
      "poi_long_description": "Discount chain stocking brand-name apparel, shoes & accessories for adults & kids, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-0f56-75f8-9da5-e6cf85a76c7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-0f56-75f8-9da5-e6cf85a76c7f",
        "storage_key": "property/6767906449166319/019fd80d-0f56-75f8-9da5-e6cf85a76c7f.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.gabesstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14545836521711926250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gabes",
      "poi_latitude": "39.9556645",
      "poi_longitude": "-76.6799321",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 717-757-2781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6_ZQSjqPyIkR6vuK1T8x3ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_978f2576-cf5a-4b16-824f-41db57fd9c44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Haines Acres Shopping Center",
      "poi_type": "Shopping",
      "poi_address": "1071 Haines Rd, East York, PA 17402, USA",
      "poi_short_description": "Shopping mall featuring a mix of stores including Dollar Tree, Ollie's, and ACE of Vapes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-11fc-77bf-9fbb-352c840730be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-11fc-77bf-9fbb-352c840730be",
        "storage_key": "property/6767906449166319/019fd80d-11fc-77bf-9fbb-352c840730be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12431555400850946426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "haines-acres-shopping-center",
      "poi_latitude": "39.9598349",
      "poi_longitude": "-76.68104160000001",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbVfwuCaPyIkRejlPmcXBhaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ae83a3f5-9546-4954-a834-ade78c8c9a2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Ollie's Bargain Outlet",
      "poi_type": "Shopping",
      "poi_address": "1081 Haines Rd, East York, PA 17402, USA",
      "poi_short_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_long_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-12ad-71dc-9e3a-84acb3883306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-12ad-71dc-9e3a-84acb3883306",
        "storage_key": "property/6767906449166319/019fd80d-12ad-71dc-9e3a-84acb3883306.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ollies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7056907052061753203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ollies-bargain-outlet",
      "poi_latitude": "39.9595336",
      "poi_longitude": "-76.68087560000001",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 717-755-3740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfZfnoCaPyIkRc_8WI5Mr72E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fbce858-db01-4d4c-ae2e-92f5128c94db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "East York Elementary School",
      "poi_type": "Education",
      "poi_address": "701 Erlen Dr, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yssd.org/ey/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9086638938059935748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-york-elementary-school",
      "poi_latitude": "39.9643443",
      "poi_longitude": "-76.6788991",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 717-885-1240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbyHHZCKPyIkRBJBLmfg5Gn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0670ae16-271d-4be6-9a81-3d94d9dc331e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Yorkshire Elementary School",
      "poi_type": "Education",
      "poi_address": "295 Mills St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yssd.org/ye/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1367021052448747849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yorkshire-elementary-school",
      "poi_latitude": "39.974717",
      "poi_longitude": "-76.6662241",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 717-885-1230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxXGyjxKPyIkRSTGwh2ei-BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_848691ba-d954-42e3-b337-03381838f0d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York Suburban Middle School",
      "poi_type": "Education",
      "poi_address": "455 Sundale Dr, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-156c-71db-abe5-a180df802fc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-156c-71db-abe5-a180df802fc2",
        "storage_key": "property/6767906449166319/019fd80d-156c-71db-abe5-a180df802fc2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.yssd.org/ms/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6172109717824523786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-suburban-middle-school",
      "poi_latitude": "39.9671117",
      "poi_longitude": "-76.671652",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 717-885-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd_pV3RaPyIkRCs6qTRa9p1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f8cf58f-6296-42d1-bd6a-6935f91941ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York Suburban High School",
      "poi_type": "Education",
      "poi_address": "1800 Hollywood Dr, York, PA 17403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-183b-73d0-95b5-63d63a8ebf5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-183b-73d0-95b5-63d63a8ebf5d",
        "storage_key": "property/6767906449166319/019fd80d-183b-73d0-95b5-63d63a8ebf5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yssd.org/hs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1093629293198358971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-suburban-high-school",
      "poi_latitude": "39.9483085",
      "poi_longitude": "-76.6934242",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 717-885-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvcVbY9OOyIkRu7kMQQxaLQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_556bca97-afcf-4d4f-9b18-3b8482735fea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "St. Joseph School",
      "poi_type": "Education",
      "poi_address": "2945 Kingston Rd, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-1869-709b-a766-b7245f719237.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-1869-709b-a766-b7245f719237",
        "storage_key": "property/6767906449166319/019fd80d-1869-709b-a766-b7245f719237.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sjyschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10540770452750994237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-joseph-school",
      "poi_latitude": "39.9705625",
      "poi_longitude": "-76.6665913",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 717-755-1797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHwuiqhOPyIkRPQsoH-FWSJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_56bff01b-a568-4805-8f05-1fd590aae283",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "The Child Development Center at York First Church of the Brethren",
      "poi_type": "Education",
      "poi_address": "2710 Kingston Rd, East York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-1c32-74cf-96f0-fefe36aec322.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-1c32-74cf-96f0-fefe36aec322",
        "storage_key": "property/6767906449166319/019fd80d-1c32-74cf-96f0-fefe36aec322.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "http://yorkfirst.org/cdchome/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2073320912404867614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-child-development-center-at-york-first-church-of-the-brethren",
      "poi_latitude": "39.9691605",
      "poi_longitude": "-76.6705712",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 717-757-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRTj0rBaPyIkRHupHiWLqxRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_569ce97a-8227-449f-95ab-f4631d093d7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Small Steps Early Learning Center - Plymouth Road",
      "poi_type": "Education",
      "poi_address": "1050 Plymouth Rd, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-2a92-74fa-83b6-df6c1525b961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-2a92-74fa-83b6-df6c1525b961",
        "storage_key": "property/6767906449166319/019fd80d-2a92-74fa-83b6-df6c1525b961.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.smallstepsyork.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5971979273379844127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "small-steps-early-learning-center---plymouth-road",
      "poi_latitude": "39.9592198",
      "poi_longitude": "-76.667125",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 717-840-1530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBwlYHz-PyIkRHxDNG4K74FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27c4307a-6b11-47f8-82bd-86cc1a296c88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Montessori Children's House of York, Inc.",
      "poi_type": "Education",
      "poi_address": "3417 E Market St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-21ce-765a-90ef-60cc7fa3e2c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-21ce-765a-90ef-60cc7fa3e2c7",
        "storage_key": "property/6767906449166319/019fd80d-21ce-765a-90ef-60cc7fa3e2c7.webp",
        "width": 751,
        "height": 563
      },
      "poi_business_url": "http://www.mchyork.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17231797547591318195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-childrens-house-of-york-inc",
      "poi_latitude": "39.9806421",
      "poi_longitude": "-76.65801119999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-757-1331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnz0UY3aPyIkRs7qgUZKkI-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e47aec81-8ebb-4a19-be30-411994e0872c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York County School of Technology",
      "poi_type": "Education",
      "poi_address": "2179 S Queen St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ytech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16839362634031089918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-county-school-of-technology",
      "poi_latitude": "39.9302213",
      "poi_longitude": "-76.68440269999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-741-0820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRZPZQguJyIkR_shozRhvsek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8463d1c4-a530-4990-ae38-13e74b2b5dce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York College of Pennsylvania",
      "poi_type": "Education",
      "poi_address": "441 Country Club Rd, York, PA 17403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf8-455c-721f-b7de-e0a484152175.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf8-455c-721f-b7de-e0a484152175",
        "storage_key": "property/6767906449166319/019fcdf8-455c-721f-b7de-e0a484152175.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.ycp.edu/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=916522750556913541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-college-of-pennsylvania",
      "poi_latitude": "39.9465999",
      "poi_longitude": "-76.72959589999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 717-846-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8dtDUVSJyIkRhT-C75UkuAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e6b08839-6d83-485b-831e-00cc240480c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "R/C Queensgate Movies 13 & IMAX",
      "poi_type": "Entertainment",
      "poi_address": "2067 Springwood Rd, York, PA 17403, USA",
      "poi_short_description": "Plush first-run cinema with 13 auditoriums, plus concessions, an arcade and an attached eatery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-21cf-75bd-86f3-13d08b417140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-21cf-75bd-86f3-13d08b417140",
        "storage_key": "property/6767906449166319/019fd80d-21cf-75bd-86f3-13d08b417140.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.rctheatres.com/theatredetails/x040l-rc-queensgate-movies-13-and-imax/?y_source=1_MjAwMTQzMzk0MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5739307007653060055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rc-queensgate-movies-13--imax",
      "poi_latitude": "39.94166",
      "poi_longitude": "-76.6934",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-854-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d76d-760b-b8be-df798e48c369.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d76d-760b-b8be-df798e48c369",
        "storage_key": "property/6767906449166319/019d0265-d76d-760b-b8be-df798e48c369.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTKxdGWJyIkR1x0SuFAdpk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_52ad0d7e-63d8-4b60-b3c7-52eddcc99e25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Appell Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "50 N George St, York, PA 17401, USA",
      "poi_short_description": "Theater duo of the Capitol (opened 1906) & the Strand (1925) now hosts live Broadway shows & more.",
      "poi_long_description": "Theater duo of the Capitol (opened 1906) & the Strand (1925) now hosts live Broadway shows & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-27b1-77f8-b252-3753c845bf08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-27b1-77f8-b252-3753c845bf08",
        "storage_key": "property/6767906449166319/019fd80d-27b1-77f8-b252-3753c845bf08.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://appellcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4451589917442442828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "appell-center-for-the-performing-arts",
      "poi_latitude": "39.9634815",
      "poi_longitude": "-76.7285053",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 717-846-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTvriaaOyIkRTAbewnE5xz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43bdf28c-839f-4895-ad13-d97526bab093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Valencia Ballroom",
      "poi_type": "Entertainment",
      "poi_address": "142 N George St, York, PA 17401, USA",
      "poi_short_description": "Swing-era ballroom hosting public and private events, once host to stars like Frank Sinatra.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-28bd-776e-ab91-1a67b89d1503.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-28bd-776e-ab91-1a67b89d1503",
        "storage_key": "property/6767906449166319/019fd80d-28bd-776e-ab91-1a67b89d1503.webp",
        "width": 1280,
        "height": 432
      },
      "poi_business_url": "http://www.valenciaballroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9694652301195568314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valencia-ballroom",
      "poi_latitude": "39.9648889",
      "poi_longitude": "-76.7291806",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 717-650-1536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1dIrv6aOyIkRumSvSedSioY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6ad0ba85-c9b8-48f8-b70a-2a50cab97843",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York County History Center",
      "poi_type": "Entertainment",
      "poi_address": "121 N Pershing Ave, York, PA 17401, USA",
      "poi_short_description": "Museum & archive presenting interactive exhibitions exploring the history of York County.",
      "poi_long_description": "Museum & archive presenting interactive exhibitions exploring the history of York County.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf8-5a44-7615-9010-4a64a6fd82bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf8-5a44-7615-9010-4a64a6fd82bc",
        "storage_key": "property/6767906449166319/019fcdf8-5a44-7615-9010-4a64a6fd82bc.webp",
        "width": 1280,
        "height": 1039
      },
      "poi_business_url": "http://www.yorkhistorycenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2652900424566138726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-county-history-center",
      "poi_latitude": "39.9631636",
      "poi_longitude": "-76.7322658",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 717-848-1587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dc2d-76fb-b9ef-7ca33e393651.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dc2d-76fb-b9ef-7ca33e393651",
        "storage_key": "property/6767906449166319/019d0265-dc2d-76fb-b9ef-7ca33e393651.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ543tyqSOyIkRZme_ZuH-0CQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac95ab13-ceae-4a72-95a8-6683a35be29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Central Market House",
      "poi_type": "Entertainment",
      "poi_address": "34 W Philadelphia St, York, PA 17401, USA",
      "poi_short_description": "Long-running fixture housing a variety of food stalls, plus fresh produce.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-2eeb-742d-ba87-6f10a5e5b401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-2eeb-742d-ba87-6f10a5e5b401",
        "storage_key": "property/6767906449166319/019fd80d-2eeb-742d-ba87-6f10a5e5b401.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.centralmarketyork.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9458613755288951243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-market-house",
      "poi_latitude": "39.9633055",
      "poi_longitude": "-76.7295898",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 717-848-2243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi4rqJKSOyIkRyxmftxi_Q4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f580b1e6-4cf7-4304-8f1d-2d014b629f63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "WellSpan Park",
      "poi_type": "Entertainment",
      "poi_address": "5 Brooks Robinson Way, York, PA 17401, USA",
      "poi_short_description": "Minor-league ballpark boasting a playground and a gift shop, and hosting firework displays.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-2e45-76c9-b532-f843cfb7bca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-2e45-76c9-b532-f843cfb7bca9",
        "storage_key": "property/6767906449166319/019fd80d-2e45-76c9-b532-f843cfb7bca9.webp",
        "width": 900,
        "height": 675
      },
      "poi_business_url": "http://wellspanpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16675230152524453935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellspan-park",
      "poi_latitude": "39.9681712",
      "poi_longitude": "-76.72823009999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-801-4487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmfUyf6GOyIkRL1gafXlRauc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a478b1d6-d0be-4e01-80bf-2550132a6052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Springettsbury Park",
      "poi_type": "Entertainment",
      "poi_address": "1501 Mt Zion Rd, York, PA 17402, USA",
      "poi_short_description": "Family-friendly park featuring a playground, basketball courts, baseball fields and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf8-6d22-745a-b3ef-95a91f0a95fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf8-6d22-745a-b3ef-95a91f0a95fe",
        "storage_key": "property/6767906449166319/019fcdf8-6d22-745a-b3ef-95a91f0a95fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.springettsbury.com/index.asp?Type=B_BASIC&SEC={C6CA1C2B-9868-4734-A7DB-A626A3F7B454}&DE={B82C0C2F-C0AE-4A74-B2FA-8CDD30019FC8}",
      "poi_directions_map_url": "https://maps.google.com/?cid=5732923352194472128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springettsbury-park",
      "poi_latitude": "39.9908489",
      "poi_longitude": "-76.6675139",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-505-0406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4fPTKKPyIkRwNgXHGpvj08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00d48cf3-d323-4dc4-adc7-35c094d4670a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York Galleria",
      "poi_type": "Entertainment",
      "poi_address": "2899 Whiteford Rd, York, PA 17402, USA",
      "poi_short_description": "Glass-roofed, bi-level mall housing familiar stores, a gym & casual dining options.",
      "poi_long_description": "Glass-roofed, bi-level mall housing familiar stores, a gym & casual dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-0b32-7039-92d7-5cb148969326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-0b32-7039-92d7-5cb148969326",
        "storage_key": "property/6767906449166319/019fd80d-0b32-7039-92d7-5cb148969326.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.yorkgalleria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3683406123084729339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-galleria",
      "poi_latitude": "39.9892226",
      "poi_longitude": "-76.67561769999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 717-840-1322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA9X-DaaPyIkR-8v2eVoWHjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d5dc26ec-b181-4fb6-a7ea-4bd88b965f04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "John Rudy County Park",
      "poi_type": "Entertainment",
      "poi_address": "400 Mundis Race Rd, York, PA 17406, USA",
      "poi_short_description": "Familiar dog park with separate areas for big & little dogs, plus a playground, trails & a creek.",
      "poi_long_description": "Familiar dog park with separate areas for big & little dogs, plus a playground, trails & a creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-3208-7368-b219-2f5ba9c7d7b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-3208-7368-b219-2f5ba9c7d7b9",
        "storage_key": "property/6767906449166319/019fd80d-3208-7368-b219-2f5ba9c7d7b9.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://yorkcountypa.gov/680/John-C-Rudy-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=724870258067042349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-rudy-county-park",
      "poi_latitude": "40.022675",
      "poi_longitude": "-76.7029146",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 717-840-7440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61wm1yaOyIkRLfBUwKhBDwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b22b442-c381-4eba-9c31-b0aa75558dad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Fat Daddy's Nightclub",
      "poi_type": "Entertainment",
      "poi_address": "2510 E Market St, York, PA 17402, USA",
      "poi_short_description": "Nightspot with a DJ'd dance club plus a separate bar & outdoor tiki deck with live entertainment.",
      "poi_long_description": "Nightspot with a DJ'd dance club plus a separate bar & outdoor tiki deck with live entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-3574-765e-955b-83474949838b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-3574-765e-955b-83474949838b",
        "storage_key": "property/6767906449166319/019fd80d-3574-765e-955b-83474949838b.webp",
        "width": 1280,
        "height": 696
      },
      "poi_business_url": "https://www.fatdaddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14453583355556684955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fat-daddys-nightclub",
      "poi_latitude": "39.9738802",
      "poi_longitude": "-76.6758667",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-755-8843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d0e1-71a7-992b-0e2c2c6b17e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d0e1-71a7-992b-0e2c2c6b17e9",
        "storage_key": "property/6767906449166319/019d0265-d0e1-71a7-992b-0e2c2c6b17e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2EECBCPyIkRm2R0x3txlcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_880679a7-73c2-4f15-a271-91e76435fbce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "WellSpan York Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1001 S George St, York, PA 17403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf8-78b6-7698-93ad-4c47ce169d7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf8-78b6-7698-93ad-4c47ce169d7f",
        "storage_key": "property/6767906449166319/019fcdf8-78b6-7698-93ad-4c47ce169d7f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.wellspan.org/locations/wellspan-york-hospital-loc0000169379",
      "poi_directions_map_url": "https://maps.google.com/?cid=4091217822778814312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellspan-york-hospital",
      "poi_latitude": "39.9454563",
      "poi_longitude": "-76.71813089999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-851-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dd83-703f-b8b4-6c349c2be24a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dd83-703f-b8b4-6c349c2be24a",
        "storage_key": "property/6767906449166319/019d0265-dd83-703f-b8b4-6c349c2be24a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0xRSUyJyIkRaG96Ae_sxjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b3fce638-e878-45ed-9a71-844ce1ac5ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "WellSpan Urgent Care - East Market Street",
      "poi_type": "Health and Wellness",
      "poi_address": "2250 E Market St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-36f9-7332-a86f-6fda83c70d29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-36f9-7332-a86f-6fda83c70d29",
        "storage_key": "property/6767906449166319/019fd80d-36f9-7332-a86f-6fda83c70d29.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.wellspan.org/locations/wellspan-urgent-care-east-market-street-loc0000168617",
      "poi_directions_map_url": "https://maps.google.com/?cid=16674166120685102402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellspan-urgent-care---east-market-street",
      "poi_latitude": "39.97343190000001",
      "poi_longitude": "-76.68250909999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 717-851-1566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQ7bjhyPyIkRQuVJRb6JZuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6efa1d54-a3cd-468e-a302-a3a455c36de7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Patient First Primary and Urgent Care - East York",
      "poi_type": "Health and Wellness",
      "poi_address": "2960 E Market St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-390c-712c-af3a-10c7ca59b028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-390c-712c-af3a-10c7ca59b028",
        "storage_key": "property/6767906449166319/019fd80d-390c-712c-af3a-10c7ca59b028.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.patientfirst.com/locations/central-pennsylvania/east-york?utm_source=local&utm_medium=organic&utm_campaign=gbp&y_source=1_NTI1NTU2MDUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026903227250395178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patient-first-primary-and-urgent-care---east-york",
      "poi_latitude": "39.9762178",
      "poi_longitude": "-76.66843",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-751-2483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4lwsQ2PyIkRKkhCkMMk6KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8985f3a5-771f-499f-b54b-1bdc78e1120d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "820 Edgewood Rd, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-0b07-7260-8698-1ee10596adca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-0b07-7260-8698-1ee10596adca",
        "storage_key": "property/6767906449166319/019fd80d-0b07-7260-8698-1ee10596adca.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/york-pa-pharmacies/820-edgewood-road-york-pa-17402/storeid=4215?WT.mc_id=LS_GOOGLE_RX_4215",
      "poi_directions_map_url": "https://maps.google.com/?cid=6870713407788840889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.9604563",
      "poi_longitude": "-76.6611448",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 717-757-6252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d6eb-711a-bc33-8620cc8f2e08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d6eb-711a-bc33-8620cc8f2e08",
        "storage_key": "property/6767906449166319/019d0265-d6eb-711a-bc33-8620cc8f2e08.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXnaqUGPyIkRuXfEGHGtWV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e0fb85b3-04e5-458f-9edd-7c50e4db4abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2350 E Market St, York, PA 17402, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-3c7a-77a0-a199-e2cd5a8ab2dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-3c7a-77a0-a199-e2cd5a8ab2dc",
        "storage_key": "property/6767906449166319/019fd80d-3c7a-77a0-a199-e2cd5a8ab2dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2350+e+market+st-york-pa-17402/id=9591",
      "poi_directions_map_url": "https://maps.google.com/?cid=16583868670897536576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.973447",
      "poi_longitude": "-76.6804209",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 717-840-3846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbCWQRuPyIkRQL6T6rC8JeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_198639ab-eca3-48ca-9e12-f2385637b83b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 E Market St Bldg B, York, PA 17402, USA",
      "poi_short_description": "Retailer offering a range of merchandise including clothing, electronics, home goods, and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-051a-7569-b36e-32c83cb5851c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-051a-7569-b36e-32c83cb5851c",
        "storage_key": "property/6767906449166319/019fd80d-051a-7569-b36e-32c83cb5851c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1529-york-pa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2139011681355998499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.97769539999999",
      "poi_longitude": "-76.6717147",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 717-755-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-d0ae2866a542",
        "storage_key": "property/6767906449166319/019d0265-d640-7512-8e78-d0ae2866a542.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmSZ42w6PyIkRI6WijcpLrx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_56e86476-616f-483c-99b2-4acd09cb7351",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1248 Greensprings Dr, York, PA 17402, USA",
      "poi_short_description": "Chain gym featuring cardio equipment and weights for fitness buffs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-3e68-7149-8fbb-8761fb0ea677.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-3e68-7149-8fbb-8761fb0ea677",
        "storage_key": "property/6767906449166319/019fd80d-3e68-7149-8fbb-8761fb0ea677.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/york-east-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5181957877015354020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.9551019",
      "poi_longitude": "-76.681799",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 717-751-2370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6chqyiPyIkRpJqJ5DsD6kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e578b02-db79-4211-a334-d21dff47bc6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Crunch Fitness - East York",
      "poi_type": "Health and Wellness",
      "poi_address": "2435 E Market St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fa49c-803b-743c-98cd-873abc55bc26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa49c-803b-743c-98cd-873abc55bc26",
        "storage_key": "property/6767906449166319/019fa49c-803b-743c-98cd-873abc55bc26.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.cruncheastyork.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=113930810515560247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---east-york",
      "poi_latitude": "39.9769917",
      "poi_longitude": "-76.6790798",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 717-430-8094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO0RT0SaPyIkRN5fA8XfDlAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b22b9c0-41dd-471c-aa56-415167b797ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "930 S Richland Ave, York, PA 17403, USA",
      "poi_short_description": "Chain gym offering 24-hour access, free weights, and a variety of cardio equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-41bc-7758-b8fa-58975f6348fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-41bc-7758-b8fa-58975f6348fd",
        "storage_key": "property/6767906449166319/019fd80d-41bc-7758-b8fa-58975f6348fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/york-pennsylvania-2146/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2146",
      "poi_directions_map_url": "https://maps.google.com/?cid=5527756962077552360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "39.9425972",
      "poi_longitude": "-76.7421006",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 717-850-9889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxnTQvuLyIkR6C5TcauJtkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ccc2c0f7-04f0-438b-96c5-a62db4b1a510",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Pure Pilates Studios",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 E Market St Suite 201, East York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mysalonsuite.com/members/angie-wert/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4366880681038011666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-pilates-studios",
      "poi_latitude": "39.9732819",
      "poi_longitude": "-76.6810646",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 717-808-3949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg05pVLuPyIkREl3JuddGmjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3aada576-46c2-443c-bf19-e3d2de57a43e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Springettsbury Park",
      "poi_type": "Recreation",
      "poi_address": "1501 Mt Zion Rd, York, PA 17402, USA",
      "poi_short_description": "Family-friendly park featuring a playground, basketball courts, baseball fields and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf8-6d22-745a-b3ef-95a91f0a95fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf8-6d22-745a-b3ef-95a91f0a95fe",
        "storage_key": "property/6767906449166319/019fcdf8-6d22-745a-b3ef-95a91f0a95fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.springettsbury.com/index.asp?Type=B_BASIC&SEC={C6CA1C2B-9868-4734-A7DB-A626A3F7B454}&DE={B82C0C2F-C0AE-4A74-B2FA-8CDD30019FC8}",
      "poi_directions_map_url": "https://maps.google.com/?cid=5732923352194472128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springettsbury-park",
      "poi_latitude": "39.9908489",
      "poi_longitude": "-76.6675139",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-505-0406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4fPTKKPyIkRwNgXHGpvj08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54251c96-1661-41f2-ad23-a0df90d97e4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Rocky Ridge Park",
      "poi_type": "Recreation",
      "poi_address": "3699 Deininger Rd, York, PA 17406, USA",
      "poi_short_description": "Forested park with miles of multi-use trails plus attractions such as a softball field & playground.",
      "poi_long_description": "Forested park with miles of multi-use trails plus attractions such as a softball field & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-4264-7675-afae-61ee573a3af4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-4264-7675-afae-61ee573a3af4",
        "storage_key": "property/6767906449166319/019fd80d-4264-7675-afae-61ee573a3af4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://yorkcountypa.gov/691/Rocky-Ridge-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14172294241589417959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocky-ridge-park",
      "poi_latitude": "40.0108529",
      "poi_longitude": "-76.65367119999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 717-840-7440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0QKkCSOyIkR51dAUoYarsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9d88606b-1758-4a1d-93cd-855942fefb9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "John Rudy County Park",
      "poi_type": "Recreation",
      "poi_address": "400 Mundis Race Rd, York, PA 17406, USA",
      "poi_short_description": "Familiar dog park with separate areas for big & little dogs, plus a playground, trails & a creek.",
      "poi_long_description": "Familiar dog park with separate areas for big & little dogs, plus a playground, trails & a creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-3208-7368-b219-2f5ba9c7d7b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-3208-7368-b219-2f5ba9c7d7b9",
        "storage_key": "property/6767906449166319/019fd80d-3208-7368-b219-2f5ba9c7d7b9.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://yorkcountypa.gov/680/John-C-Rudy-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=724870258067042349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-rudy-county-park",
      "poi_latitude": "40.022675",
      "poi_longitude": "-76.7029146",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 717-840-7440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61wm1yaOyIkRLfBUwKhBDwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd607b4d-0ec9-4ff9-a327-7d59d0c5b3e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Nixon Park Nature Center",
      "poi_type": "Recreation",
      "poi_address": "5922 Nixon Dr, York, PA 17403, USA",
      "poi_short_description": "Park featuring a nature center, museum and hiking trails plus birds and kid-friendly events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-4672-757c-b610-187d93cea36e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-4672-757c-b610-187d93cea36e",
        "storage_key": "property/6767906449166319/019fd80d-4672-757c-b610-187d93cea36e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://yorkcountypa.gov/facilities/facility/details/Nixon-Nature-Center-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=4224777979346528046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nixon-park-nature-center",
      "poi_latitude": "39.8852764",
      "poi_longitude": "-76.7320582",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 717-428-1961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8jXlfCJyIkRLqfXOTBtoTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_518cb518-60a3-4140-b35e-443a8b8ac5ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "William H. Kain County Park",
      "poi_type": "Recreation",
      "poi_address": "274 Hess Farm Rd, York, PA 17407, USA",
      "poi_short_description": "Scenic park featuring trails for hiking, biking & horseback riding, plus 2 lakes & kayak rentals.",
      "poi_long_description": "Scenic park featuring trails for hiking, biking & horseback riding, plus 2 lakes & kayak rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-62cc-7277-b560-89687300d23c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-62cc-7277-b560-89687300d23c",
        "storage_key": "property/6767906449166319/019fd80d-62cc-7277-b560-89687300d23c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.yorkcountyparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13190749428019169899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-h-kain-county-park",
      "poi_latitude": "39.888878",
      "poi_longitude": "-76.70129109999999",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 717-840-7440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6bEFrriJyIkRawpFmrf0Drc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e5286ba3-a793-4805-ba7d-02bfc1a98469",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Kids Kingdom Playground",
      "poi_type": "Recreation",
      "poi_address": "76 Revere Rd, York, PA 17402, USA",
      "poi_short_description": "Popular playground featuring swings, slides, and safe zones for children to run around with fenced perimeters.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-4a44-720e-9dba-2c2c6edbbb32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-4a44-720e-9dba-2c2c6edbbb32",
        "storage_key": "property/6767906449166319/019fd80d-4a44-720e-9dba-2c2c6edbbb32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7325958694800737948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-kingdom-playground",
      "poi_latitude": "39.9227605",
      "poi_longitude": "-76.6779038",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJeVfuueIyIkRnEbISp4Iq2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ec2636d1-7c49-41c6-9031-d79b32f5e7aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Reid Menzer Memorial Skatepark",
      "poi_type": "Recreation",
      "poi_address": "941 Vander Ave, York, PA 17403, USA",
      "poi_short_description": "Free recreational spot for skateboarders with an array of obstacles and surface types.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-4dbd-760c-8573-5ddd224a9133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-4dbd-760c-8573-5ddd224a9133",
        "storage_key": "property/6767906449166319/019fd80d-4dbd-760c-8573-5ddd224a9133.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://reidmenzermemorialskatepark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3403877276429317906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reid-menzer-memorial-skatepark",
      "poi_latitude": "39.9526469",
      "poi_longitude": "-76.70692919999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkS__2suOyIkREveXMFkAPS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3d126814-fda7-44e8-aff9-e2d1a4fc1dad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Susquehanna Riverlands State Park",
      "poi_type": "Recreation",
      "poi_address": "River Farm Rd, York, PA 17406, USA",
      "poi_short_description": "Undeveloped river, hiking area featuring a dirt road and a lookout point.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-50eb-70f8-b099-d8a86dd90bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-50eb-70f8-b099-d8a86dd90bf1",
        "storage_key": "property/6767906449166319/019fd80d-50eb-70f8-b099-d8a86dd90bf1.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/SusquehannaRiverlandsStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1901332761354244202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "susquehanna-riverlands-state-park",
      "poi_latitude": "40.0432122",
      "poi_longitude": "-76.62359599999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 717-252-1134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8PjulObyIkRahBVoBLkYho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd91ddf5-b26e-4d25-925a-bbe1cf5beab4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Codorus State Park",
      "poi_type": "Recreation",
      "poi_address": "2600 Smith Station Rd, Hanover, PA 17331, USA",
      "poi_short_description": "Rolling 3,490-acre park has Lake Marburg for fishing & boating plus hiking, hunting & camping.",
      "poi_long_description": "Rolling 3,490-acre park has Lake Marburg for fishing & boating plus hiking, hunting & camping.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-53a3-7624-a730-603c6bcc227c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-53a3-7624-a730-603c6bcc227c",
        "storage_key": "property/6767906449166319/019fd80d-53a3-7624-a730-603c6bcc227c.webp",
        "width": 1280,
        "height": 763
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/CodorusStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12623558444058757265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "codorus-state-park",
      "poi_latitude": "39.7886416",
      "poi_longitude": "-76.9070606",
      "poi_miles_from_property": "22.7 mi",
      "poi_walking_minutes": "8 hours 27 mins",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 717-637-2816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxx_pn5cyIkRkUiBu4XjL68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5bd29315-0119-409c-bd48-8d94e3cb4b01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Heritage Rail Trail County Park Trailhead",
      "poi_type": "Recreation",
      "poi_address": "Rudy Park, Mt Wolf, PA 17347, USA",
      "poi_short_description": "Dog-friendly park featuring paved walking paths as well as wooded trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-570f-75ec-b039-5da6b5ff0672.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-570f-75ec-b039-5da6b5ff0672",
        "storage_key": "property/6767906449166319/019fd80d-570f-75ec-b039-5da6b5ff0672.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.traillink.com/trail/heritage-rail-trail-county-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=442743498461302854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-rail-trail-county-park-trailhead",
      "poi_latitude": "40.0232808",
      "poi_longitude": "-76.70218969999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dcdc-77a6-8797-03f290e0a40e",
        "storage_key": "property/6767906449166319/019d0265-dcdc-77a6-8797-03f290e0a40e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj4ffJySOyIkRRlBmuN3wJAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c009588-d7d2-4044-9452-b57d83a72e0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "WellSpan York Hospital",
      "poi_type": "Major Employers",
      "poi_address": "1001 S George St, York, PA 17403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf8-78b6-7698-93ad-4c47ce169d7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf8-78b6-7698-93ad-4c47ce169d7f",
        "storage_key": "property/6767906449166319/019fcdf8-78b6-7698-93ad-4c47ce169d7f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.wellspan.org/locations/wellspan-york-hospital-loc0000169379",
      "poi_directions_map_url": "https://maps.google.com/?cid=4091217822778814312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellspan-york-hospital",
      "poi_latitude": "39.9454563",
      "poi_longitude": "-76.71813089999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-851-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dd83-703f-b8b4-6c349c2be24a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dd83-703f-b8b4-6c349c2be24a",
        "storage_key": "property/6767906449166319/019d0265-dd83-703f-b8b4-6c349c2be24a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0xRSUyJyIkRaG96Ae_sxjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db7249d3-e295-4ff4-af80-250e4ca330ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "UPMC Memorial",
      "poi_type": "Major Employers",
      "poi_address": "1701 Innovation Dr, York, PA 17408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-5afe-710a-bedf-1634371e7997.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-5afe-710a-bedf-1634371e7997",
        "storage_key": "property/6767906449166319/019fd80d-5afe-710a-bedf-1634371e7997.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.upmc.com/locations/hospitals/memorial?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=hospital-cpa-upmc-memorial",
      "poi_directions_map_url": "https://maps.google.com/?cid=17630279094802656533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-memorial",
      "poi_latitude": "39.9821877",
      "poi_longitude": "-76.7685683",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 717-843-8623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dd83-703f-b8b4-6c349c2be24a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dd83-703f-b8b4-6c349c2be24a",
        "storage_key": "property/6767906449166319/019d0265-dd83-703f-b8b4-6c349c2be24a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbbFveCOyIkRFS21cG1Vq_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_944236ef-45e5-4699-95d5-37f4b3e0a1e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Harley-Davidson York Vehicle Operations",
      "poi_type": "Major Employers",
      "poi_address": "1425 Eden Road, York, PA 17402, USA",
      "poi_short_description": "Legendary brand of American motorcycles, plus apparel & more at some branches.",
      "poi_long_description": "Legendary brand of American motorcycles, plus apparel & more at some branches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-5d4e-7149-b38d-e553fe618e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-5d4e-7149-b38d-e553fe618e08",
        "storage_key": "property/6767906449166319/019fd80d-5d4e-7149-b38d-e553fe618e08.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://jobs.harley-davidson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14534957281338991163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harley-davidson-york-vehicle-operations",
      "poi_latitude": "39.9866825",
      "poi_longitude": "-76.7129436",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQ1cQgCPyIkROyKwS6OKtsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_034879e3-08af-44f4-b85f-a61620eb6a7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York College of Pennsylvania",
      "poi_type": "Major Employers",
      "poi_address": "441 Country Club Rd, York, PA 17403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fcdf8-455c-721f-b7de-e0a484152175.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf8-455c-721f-b7de-e0a484152175",
        "storage_key": "property/6767906449166319/019fcdf8-455c-721f-b7de-e0a484152175.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.ycp.edu/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=916522750556913541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-college-of-pennsylvania",
      "poi_latitude": "39.9465999",
      "poi_longitude": "-76.72959589999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 717-846-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8dtDUVSJyIkRhT-C75UkuAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_74479f65-11b5-4de2-930a-8415ebfa3a71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York County Administrative Center",
      "poi_type": "Major Employers",
      "poi_address": "28 E Market St, York, PA 17401, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-6235-766b-b601-42e508f1a676.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-6235-766b-b601-42e508f1a676",
        "storage_key": "property/6767906449166319/019fd80d-6235-766b-b601-42e508f1a676.webp",
        "width": 1280,
        "height": 790
      },
      "poi_business_url": "http://yorkcountypa.gov/county-administration/row-officers/treasurer.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5208221160526432210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-county-administrative-center",
      "poi_latitude": "39.9626118",
      "poi_longitude": "-76.72659709999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 717-771-9603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-e182-7459-ae09-1df3d49b6a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-e182-7459-ae09-1df3d49b6a33",
        "storage_key": "property/6767906449166319/019d0265-e182-7459-ae09-1df3d49b6a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSUdyKWOyIkR0sfZGI1RR0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_51068d3f-6ec4-4ac4-850e-a14ce5769ae8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "York County School of Technology",
      "poi_type": "Major Employers",
      "poi_address": "2179 S Queen St, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ytech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16839362634031089918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-county-school-of-technology",
      "poi_latitude": "39.9302213",
      "poi_longitude": "-76.68440269999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 717-741-0820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d645-7075-9437-ab2352ebaf84",
        "storage_key": "property/6767906449166319/019d0265-d645-7075-9437-ab2352ebaf84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRZPZQguJyIkR_shozRhvsek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_813d1cc6-a6ea-430e-ae9a-ae1b9a3bbfce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Glatfelter Healthcare Practice",
      "poi_type": "Major Employers",
      "poi_address": "183 Leader Heights Rd, York, PA 17403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.glatfelterhealthcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2546892439565540264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glatfelter-healthcare-practice",
      "poi_latitude": "39.91163299999999",
      "poi_longitude": "-76.7008091",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 717-696-6685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dbb9-75ec-8416-78b74f677d10",
        "storage_key": "property/6767906449166319/019d0265-dbb9-75ec-8416-78b74f677d10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryaJ6giJyIkRqJtuBS5hWCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4738a15a-6eb3-4add-a382-73239d8b46af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "poi_name": "Springettsbury Township Police Department",
      "poi_type": "Major Employers",
      "poi_address": "1501 Mt Zion Rd, York, PA 17402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019fd80d-63c6-746a-8aac-f251e9ecedf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd80d-63c6-746a-8aac-f251e9ecedf9",
        "storage_key": "property/6767906449166319/019fd80d-63c6-746a-8aac-f251e9ecedf9.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://york.crimewatchpa.com/springettsburytwppd",
      "poi_directions_map_url": "https://maps.google.com/?cid=10332342373738619284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springettsbury-township-police-department",
      "poi_latitude": "39.9911489",
      "poi_longitude": "-76.6704328",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 717-757-3525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019d0265-e182-7459-ae09-1df3d49b6a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-e182-7459-ae09-1df3d49b6a33",
        "storage_key": "property/6767906449166319/019d0265-e182-7459-ae09-1df3d49b6a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3opeKSPyIkRlCFoVKXaY48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_090d4ee2-4f7d-49d4-88ac-ad88f3d63c37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c2b4fa38-a074-4143-812a-d72b614e5012",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5a173fb7-c967-4c8c-b970-6472223521e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_02790185-9911-4c4a-a88b-a688c01917d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c4188122-3a86-4d2a-b280-70f7b827c661",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a1b6b60d-0f58-4f7a-9ba7-1bd217d7c6ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_1d7bd18a1d048eb5d067edba",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "rating": "5",
      "name": "César Aguilera",
      "text": "I was in a rush to find a good apartment and looked all over town, but from the moment I reached out to Greenspring, the experience was different. The team was warm, helpful, and incredibly responsive from the start. Wesley in particular went above and beyond. He showed me the available units as many times as I needed to feel confident in my decision. He answered every question, provided thoughtful guidance, and helped me move through the leasing process at record speed. Thanks to his support, I was able to tour, select, and move into my apartment in no time. He even helped me get all my services up and running without delays. It’s been a week since I moved in, and I couldn’t be happier with my decision. The apartment is comfortable, the complex is well maintained, and the customer service has been outstanding. Highly recommended.",
      "date": "2025-06-21",
      "title": "false"
    },
    {
      "id": "ec_c9db6f0a6467998defe5f826",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "rating": "5",
      "name": "Bobbi Billman",
      "text": "Beautiful property, amazing customer service, and a great location.  I was incredibly impressed by Wesley - his knowledge, willingness to help me make the best choice, and the quality of service he provided is the best I have come across.  I highly recommend working with Wesley!  Could not be happier with my experience.",
      "date": "2025-06-21",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_10f6bd60-5c33-4372-b4e3-8189870f5572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166319/019df1c8-607c-75eb-8ace-7d377f0a48e3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019df1c8-607c-75eb-8ace-7d377f0a48e3",
        "storage_key": "property/6767906449166319/019df1c8-607c-75eb-8ace-7d377f0a48e3.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " Greenspring",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62e44aef92728e11543e57a3&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_2a69717d7f87b9e277d2c2a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429508",
      "name": "Admin Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_25e8397df9e92ad01800137d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429510",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b603c961d2fffb57575a880d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429511",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_355d00028e0188c69098df6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429513",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_0d9f08fffdaad23866afad4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429514",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a5a26a3d48f7f1bd06757160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429515",
      "name": "Pet Fee",
      "description": "false",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_47afe4eb67b75df197283b73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429517",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_61766da50349ee92f0a024d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429520",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_95d10066b823f8a3b06ae80f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429522",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c5b8783a00165b1a72d3de8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "429523",
      "name": "Trash Service",
      "description": "false",
      "amount": 12,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cacf91663ac6257b7b66552b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "536754",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1b4361aa0e240daa1e3dc8f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "536755",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_dd4312ee7358fbbe475709b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "543116",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_367479b056d42fb9c9693806",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "543117",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_757c7651c59eff07a88f4844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "543122",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6fddfe4e56531f8a3b5ca8b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "832524",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c5a156ae745c6a46792c90f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "832529",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a71f7bcaa8039f0ed524f63d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "832534",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0cc34a1e0082b1908ca07ced",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "832537",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8ec770c1ae4daa109dfa9629",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "engrain",
      "external_id": "832540",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a12fb-f5d5-7759-b2bb-c0ebceaadb9a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-greenspring-apartments-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319"
    },
    {
      "lead_collector_id": "019c3043-4f09-736c-930c-482a7f6c5f32",
      "lead_source": "FACEBOOK_ADS",
      "name": "greenspring",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319"
    },
    {
      "lead_collector_id": "019c3043-4f7d-707d-8fcf-94d61543980d",
      "lead_source": "LANDING_PAGE",
      "name": "greenspring",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "in-unit-washer-dryer-east-york-693",
      "search_query": "in unit washer dryer apartments East York",
      "category": "Amenity",
      "h1_title": "In-Unit Washer Dryer Apartments in East York",
      "h2_subtitle": "Discover the convenience of in-unit washer dryer apartments available in East York. Greenspring Apartments offers modern living with luxurious amenities.",
      "page_copy": "If you're searching for in-unit washer dryer apartments in East York, Greenspring Apartments is your ideal choice. Located in the heart of East York, our community provides a perfect blend of comfort and convenience. Imagine the ease and comfort of having a washer and dryer right in your own apartment, saving you time and effort.\n\nOur pet-friendly complex also boasts a variety of amenities including a business center, community playground, and renovated bathrooms. Whether you're staying short-term or planning a longer stay, Greenspring Apartments offers flexible leasing options tailored to fit your needs. Experience the best of apartment living with the added perk of in-unit laundry for ultimate convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartments - East York",
      "seo_description": "Find in-unit washer dryer apartments in East York at Greenspring Apartments. Enjoy modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-york-county-243",
      "search_query": "pet friendly apartments York County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in York County",
      "h2_subtitle": "Looking for a pet friendly apartment in York County? Greenspring Apartments welcomes your furry friends with open arms and a range of amenities.",
      "page_copy": "Greenspring Apartments in East York offers fantastic pet-friendly apartments in York County, making it easier than ever to bring your furry friends along. We understand that pets are family, which is why our community is designed to accommodate them. Explore our landscaped grounds and enjoy shared spaces like the community playground, which is part of our AION Play initiative.\n\nBeyond being pet-friendly, Greenspring Apartments also features a business center, perfect for remote work, and thoughtfully renovated bathrooms. Choose us for short-term leases that suit every lifestyle and enjoy living in a community that truly cares. Join us at Greenspring Apartments, where both you and your pets can feel right at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments - York County",
      "seo_description": "Discover pet friendly apartments in York County at Greenspring. Enjoy renovated units, a playground, and a welcoming environment for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "apartments-with-swimming-pool-east-york-12",
      "search_query": "apartments with swimming pool East York",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in East York",
      "h2_subtitle": "While Greenspring Apartments doesn't feature a pool, we offer modern amenities and spacious living options in East York.",
      "page_copy": "If you're seeking apartments with swimming pool access in East York, consider Greenspring Apartments for its enriched community lifestyle. While we don't have a swimming pool, we provide other amenities that promise a comfortable and convenient living experience. Our pet-friendly complex in East York features a business center and a community playground as part of our AION Connect and AION Play initiatives.\n\nExpect more with our renovated bathrooms and flexible short-term leasing options. Embrace the vibrant community feel with modern conveniences right at your doorstep. Greenspring Apartments is strategically located in East York, offering easy access to local attractions and making it a great choice for those who value both location and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool - East York",
      "seo_description": "Explore Greenspring Apartments in East York for modern amenities. Although pool access isn't available, enjoy our renovated spaces and community features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "dog-park-apartments-17402-790",
      "search_query": "dog park apartments 17402",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near 17402",
      "h2_subtitle": "Explore dog park apartments in the 17402 area at Greenspring. Our pet-friendly community is ideal for you and your furry friends.",
      "page_copy": "For those looking for dog park apartments in the 17402 vicinity, Greenspring Apartments is a perfect match, offering a pet-friendly environment with vast outdoor spaces for you and your pet to enjoy. Although we don’t have a dedicated dog park, our community features a playground and plenty of room to roam, ensuring that you and your pets have a joyful living experience.\n\nGreenspring Apartments provides an array of amenities such as a business center and updated living spaces with renovated bathrooms. Our short-term lease options allow flexibility while our pet-friendly policy assures that your companions feel right at home. Choose Greenspring Apartments in East York for a welcoming atmosphere where pets are cherished and residents thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments - 17402",
      "seo_description": "Find pet-friendly apartments at Greenspring near 17402. Enjoy plenty of room to roam and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "apartment-renovated-kitchen-east-york-200",
      "search_query": "apartment with renovated kitchen East York",
      "category": "Amenity",
      "h1_title": "Apartment with Renovated Kitchen East York",
      "h2_subtitle": "Discover apartment living with renovated kitchens in East York. Greenspring Apartments offers modern comforts and convenient location.",
      "page_copy": "Experience stylish living at Greenspring Apartments where convenience and modern upgrades meet. While our community primarily features renovated bathrooms, we offer spacious and well-equipped kitchens that cater to your culinary needs. Located in vibrant East York, our apartments provide the perfect setting to enjoy all the comforts of home.\n\nBesides offering functional kitchens, Greenspring Apartments boasts a range of amenities including a business center and playground, designed to enhance your lifestyle. Our pet-friendly policy and short-term lease options ensure flexibility and comfort for all residents. Choose Greenspring Apartments in East York for a lifestyle that blends modern convenience with a welcoming community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Renovated Kitchen Apartment - East York",
      "seo_description": "Live in style in East York at Greenspring Apartments. While kitchens may not be renovated, enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-east-york-pa-609",
      "search_query": "one bedroom apartments east york pa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in East York, PA",
      "h2_subtitle": "Discover one bedroom apartments in East York, PA at Greenspring. Experience modern living with great amenities and flexible options.",
      "page_copy": "If you're searching for one bedroom apartments in East York, PA, Greenspring Apartments offers the ideal solution with beautifully designed spaces and a variety of community features. Our pet-friendly environment provides a welcoming atmosphere for both you and your pets, complete with a community playground and modern business center.\n\nGreenspring Apartments offers flexible leasing options, including short-term leases, catering to your unique living needs. Each apartment is equipped with stylish amenities, highlighted by our renovated bathrooms, ensuring a comfortable and convenient living experience. Located in the heart of York County, Greenspring Apartments presents an extraordinary blend of quality and practicality in a wonderful location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments - East York, PA",
      "seo_description": "Find spacious one bedroom apartments at Greenspring in East York, PA. Enjoy modern amenities and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-york-county-910",
      "search_query": "two bedroom apartments york county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in York County",
      "h2_subtitle": "Explore two bedroom apartments in York County at Greenspring. Enjoy spacious living with top-notch amenities in East York.",
      "page_copy": "Greenspring Apartments offers spacious two bedroom apartments in the heart of York County, perfect for families or individuals seeking additional space. Our community is located in East York, combining the best of suburban comfort with convenient access to local amenities and businesses.\n\nAt Greenspring, residents can enjoy a variety of community features including a business center and playground, alongside pet-friendly policies that welcome your furry friends. Each apartment is designed with modern living in mind, featuring renovated bathrooms and flexible short-term lease options. Experience a harmonious blend of style, comfort, and convenience at Greenspring Apartments in York County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments - York County",
      "seo_description": "Discover spacious two bedroom apartments at Greenspring in York County. Enjoy modern amenities and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-17402-558",
      "search_query": "three bedroom apartments near 17402",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 17402",
      "h2_subtitle": "Find three bedroom apartments near 17402 at Greenspring. Enjoy spacious living and modern amenities in East York, PA.",
      "page_copy": "For those in need of extra space, Greenspring Apartments offers comfortable three bedroom apartments near the 17402 area in East York, PA. Our spacious floor plans are perfect for families or individuals looking for room to grow in a convenient and vibrant location.\n\nNestled in York County, Greenspring Apartments boasts a variety of amenities, including a community playground and a business center, ensuring a balanced lifestyle of work and play. Our pet-friendly policy and short-term lease options provide further flexibility to our residents. Experience the perfect blend of comfort and convenience with Greenspring Apartments, just a stone's throw from everything East York has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments - Near 17402",
      "seo_description": "Explore three bedroom apartments at Greenspring near 17402. Enjoy modern amenities and spacious living in East York, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "apartments-near-york-college-of-pa-east-york-277",
      "search_query": "apartments near York College of Pennsylvania East York",
      "category": "School",
      "h1_title": "Apartments Near York College of PA, East York",
      "h2_subtitle": "Discover apartments near York College of Pennsylvania in East York. Enjoy a convenient and comfortable living experience at Greenspring Apartments.",
      "page_copy": "If you're seeking apartments near York College of Pennsylvania in East York, Greenspring Apartments is your ideal choice. Our community offers a perfect blend of proximity and comfort, making it convenient for students and faculty alike.\n\nLocated in the vibrant area of East York, our pet-friendly apartments provide modern amenities like a well-equipped business center and a lively community playground. Whether you're looking for a short-term lease or a long-term home, our renovated spaces, including stylish bathrooms, cater to every need. Experience the convenience of living close to campus while enjoying the serene environment of Greenspring Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near York College of PA, East York",
      "seo_description": "Find convenient apartments near York College of PA in East York at Greenspring. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "apartments-close-to-penn-state-york-17402-85",
      "search_query": "apartments close to Penn State York 17402",
      "category": "School",
      "h1_title": "Apartments Close to Penn State York 17402",
      "h2_subtitle": "Find apartments close to Penn State York in the 17402 area. Experience comfortable living at Greenspring Apartments in East York.",
      "page_copy": "Greenspring Apartments offers a perfect home for those looking for apartments close to Penn State York in the 17402 zip code. Our community combines convenient access to the university with the comfort of a welcoming environment in East York.\n\nResidents can enjoy a variety of amenities, including a business center designed for productive days and a community playground for leisure. Our pet-friendly apartments, along with options for short-term leases and beautifully renovated bathrooms, make Greenspring an ideal choice for students, faculty, and staff at Penn State York. Discover the benefits of living near campus in a community that feels like home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Penn State York 17402",
      "seo_description": "Discover Greenspring Apartments close to Penn State York in the 17402 area. Enjoy modern amenities and a convenient location in East York.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "greenspring-apartments-near-admissions-welcome-center-970",
      "search_query": "Greenspring Apartments near Admissions Welcome Center York County",
      "category": "School",
      "h1_title": "Greenspring Apts Near Admissions Center, York",
      "h2_subtitle": "Explore Greenspring Apartments near the Admissions Welcome Center in York County. Enjoy a welcoming community in East York.",
      "page_copy": "Greenspring Apartments offers an ideal living solution for those seeking proximity to the Admissions Welcome Center in York County. Our community not only provides convenient access but also a comfortable and modern living environment in East York.\n\nWith an emphasis on flexibility and lifestyle, Greenspring Apartments offers short-term leases and is pet-friendly, ensuring a seamless living experience. Residents can take advantage of our business center and community playground, creating a balanced lifestyle of work and leisure. Enhance your living situation by choosing a community that provides both convenience and comfort near key York County landmarks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Greenspring Apts Near Admissions Center, York",
      "seo_description": "Live near the Admissions Welcome Center at Greenspring Apartments in York County. Enjoy convenient access and modern amenities in East York.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "apartments-near-wellspan-york-hospital-east-york-605",
      "search_query": "apartments near WellSpan York Hospital East York",
      "category": "Hospital",
      "h1_title": "Apts Near WellSpan York Hospital, East York",
      "h2_subtitle": "Find convenient apartments near WellSpan York Hospital in East York. Enjoy a supportive community at Greenspring Apartments.",
      "page_copy": "For those looking for apartments near WellSpan York Hospital in East York, Greenspring Apartments provides an excellent option. Our community combines a prime location with comfortable amenities, offering a perfect environment for healthcare professionals and hospital visitors.\n\nSituated within easy reach of the hospital, our community offers pet-friendly living and the flexibility of short-term leases. With renovated bathrooms and amenities such as a business center and community playground, Greenspring Apartments caters to both your professional and personal needs. Experience the ease of living close to WellSpan York Hospital while enjoying the quality and comfort of our East York community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near WellSpan York Hospital, East York",
      "seo_description": "Discover Greenspring Apartments near WellSpan York Hospital, East York. Enjoy modern living and close proximity to healthcare facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "greenspring-apartments-close-to-upmc-memorial-17402-156",
      "search_query": "Greenspring Apartments close to UPMC Memorial 17402",
      "category": "Hospital",
      "h1_title": "Greenspring Apts Near UPMC Memorial 17402",
      "h2_subtitle": "Explore Greenspring Apartments close to UPMC Memorial in the 17402 area. Enjoy a convenient lifestyle in East York.",
      "page_copy": "Greenspring Apartments provides the perfect location for those seeking accommodation close to UPMC Memorial in the 17402 zip code. Our community offers both convenience and comfort, making it an excellent choice for hospital staff and visitors.\n\nLocated in East York, Greenspring Apartments features amenities that enhance your living experience, including pet-friendly homes, short-term leases, and renovated bathrooms. Our business center and community playground further cater to the diverse needs of our residents. Choose Greenspring Apartments for a harmonious balance of location and modern living near UPMC Memorial.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Greenspring Apts Near UPMC Memorial 17402",
      "seo_description": "Find Greenspring Apartments near UPMC Memorial in the 17402 area. Enjoy convenient access and modern amenities in East York.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "apartments-near-cousler-park-east-york-92",
      "search_query": "apartments near Cousler Park East York",
      "category": "Park",
      "h1_title": "Apts Near Cousler Park, East York",
      "h2_subtitle": "Discover apartments near Cousler Park in East York. Greenspring Apartments offers modern amenities in a prime location.",
      "page_copy": "For those in search of apartments near Cousler Park in East York, Greenspring Apartments offers a wonderful living opportunity. Our community is ideally positioned to provide both proximity to the park and the conveniences of modern living.\n\nResidents at Greenspring Apartments enjoy a range of amenities, including pet-friendly leases, flexible short-term options, and renovated bathrooms. Our community playground and business center further enhance the quality of life, ensuring residents can enjoy recreation and work with ease. Experience the perfect blend of location and lifestyle at Greenspring Apartments, just a stone's throw from Cousler Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Cousler Park, East York",
      "seo_description": "Live at Greenspring Apartments near Cousler Park, East York. Enjoy convenient access to outdoor activities and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "rocky-ridge-park-apartments-york-county-238",
      "search_query": "Rocky Ridge Park apartments in York County",
      "category": "Park",
      "h1_title": "Apts Near Rocky Ridge Park, York County",
      "h2_subtitle": "Experience the best of York County with apartments near Rocky Ridge Park. Discover the comfort at Greenspring Apartments.",
      "page_copy": "For nature lovers looking for Rocky Ridge Park apartments in York County, Greenspring Apartments offers a premier choice. Located just a short drive from the park, our community combines the best of outdoor access and modern conveniences.\n\nAt Greenspring Apartments, residents enjoy a wealth of amenities, from pet-friendly options to short-term leases that offer flexibility. Renovated bathrooms and community features like a business center and playground ensure a comfortable lifestyle. Make Greenspring Apartments your home and embrace the beautiful surroundings of York County while enjoying a vibrant community life close to Rocky Ridge Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Rocky Ridge Park, York County",
      "seo_description": "Find comfort and convenience at Greenspring Apartments near Rocky Ridge Park in York County. Enjoy proximity to nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "john-rudy-county-park-nearby-apartments-pa-688",
      "search_query": "John Rudy County Park nearby apartments PA",
      "category": "Park",
      "h1_title": "Apts Near John Rudy County Park, PA",
      "h2_subtitle": "Find nearby apartments to John Rudy County Park in PA. Greenspring Apartments offers a perfect blend of location and amenities.",
      "page_copy": "If you're seeking nearby apartments to John Rudy County Park in PA, look no further than Greenspring Apartments. Our community is strategically located to provide residents with quick access to the park's natural beauty and recreational facilities.\n\nGreenspring Apartments is designed to meet diverse living needs with pet-friendly policies and short-term lease flexibility. With amenities such as renovated bathrooms, a business center, and a playground, residents can enjoy both luxury and practicality. Move into Greenspring Apartments and relish the tranquil environment of York County with John Rudy County Park just moments away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near John Rudy County Park, PA",
      "seo_description": "Discover Greenspring Apartments near John Rudy County Park, PA. Enjoy convenience and modern living close to nature in York County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "springettsbury-park-east-york-apartments-43",
      "search_query": "Springettsbury Park East York apartments",
      "category": "Park",
      "h1_title": "Apts Near Springettsbury Park, East York",
      "h2_subtitle": "Discover apartments near Springettsbury Park in East York. Greenspring Apartments offers a vibrant community with modern amenities.",
      "page_copy": "For those searching for East York apartments close to Springettsbury Park, Greenspring Apartments presents an ideal option. Situated in a prime location, our community provides easy access to the recreational joys of the park and the conveniences of urban living.\n\nGreenspring Apartments is replete with features to enhance residents' lifestyles. From pet-friendly accommodations and short-term lease options to renovated bathrooms, business centers, and playgrounds, we ensure that your living experience is both comfortable and convenient. Experience the best of both worlds with Greenspring Apartments, where urban meets nature near Springettsbury Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Springettsbury Park, East York",
      "seo_description": "Enjoy modern living at Greenspring Apartments near Springettsbury Park, East York. Experience convenience and community in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166319",
      "source": "custom",
      "page_item_url": "nixon-park-nature-center-close-apartments-17402-179",
      "search_query": "Nixon Park Nature Center close apartments 17402",
      "category": "Park",
      "h1_title": "Apts Near Nixon Park Nature Center, 17402",
      "h2_subtitle": "Find apartments close to Nixon Park Nature Center in the 17402 area. Greenspring Apartments offers a perfect blend of comfort and location.",
      "page_copy": "For those seeking apartments close to Nixon Park Nature Center in the 17402 area, Greenspring Apartments is an exemplary choice. Embrace the harmonious blend of nature and necessity with our community providing easy access to the serenity of Nixon Park.\n\nGreenspring Apartments boasts a variety of benefits for residents, including flexible short-term leases, pet-friendly living, and renovated amenities. With a playground and business center available, you can enjoy the conveniences of modern life while staying connected to nature. Choose Greenspring Apartments for a unique living experience close to Nixon Park Nature Center in East York, PA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Nixon Park Nature Center, 17402",
      "seo_description": "Explore Greenspring Apartments near Nixon Park Nature Center, 17402. Enjoy nature's proximity with modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5056"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976244832"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973277"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NW3T4W6B"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livegreenspring.fatwin.com/api/websites/resources/1?x=QzRPeUhTYW15a0QrYnN4eEZldVVBSmNCMmIxZVFGRlU5S0QxdlJWNmg0Yi9kb09ZUXF1RjBIOC9tRy9WUjMzM2IzV2J4MzFMKzBJMkwvbzZscnJtSWc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywym2r1wq0"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9549eba6-43e6-11ef-860e-a3d1c32d3a5f"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549eba6-43e6-11ef-860e-a3d1c32d3a5f/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549eba6-43e6-11ef-860e-a3d1c32d3a5f/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkRsVzlIRXNxZThrT2hvUE8wNWVaSmc9PSIsInZhbHVlIjoiY1dKZ3lqRVoyVklyekRGby9za0t6QT09IiwibWFjIjoiNDVmN2E2ZTZmN2YzMzM0ZGQ4NGI2ODFmMjViNDIyY2NmMzFlODc4ZGVhMzgxYjUzYzI4OThkY2M4ZGUwNzIwYSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5056",
  "custom_repli_id": "9976244832",
  "custom_realpage_id": "4973277",
  "custom_google_gtm_id": "GTM-NW3T4W6B",
  "custom_perq_script_url": "https://livegreenspring.fatwin.com/api/websites/resources/1?x=QzRPeUhTYW15a0QrYnN4eEZldVVBSmNCMmIxZVFGRlU5S0QxdlJWNmg0Yi9kb09ZUXF1RjBIOC9tRy9WUjMzM2IzV2J4MzFMKzBJMkwvbzZscnJtSWc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/1ywym2r1wq0",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9549eba6-43e6-11ef-860e-a3d1c32d3a5f",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549eba6-43e6-11ef-860e-a3d1c32d3a5f/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549eba6-43e6-11ef-860e-a3d1c32d3a5f/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkRsVzlIRXNxZThrT2hvUE8wNWVaSmc9PSIsInZhbHVlIjoiY1dKZ3lqRVoyVklyekRGby9za0t6QT09IiwibWFjIjoiNDVmN2E2ZTZmN2YzMzM0ZGQ4NGI2ODFmMjViNDIyY2NmMzFlODc4ZGVhMzgxYjUzYzI4OThkY2M4ZGUwNzIwYSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "6dfcae91-7f1f-4b16-b173-dcaa9910405a",
  "custom_audioeye_site_hash": "7707dda5ba44855fb02529d64cbed1ff"
};

export const generatedAt = '2026-10-22T20:07:14.737Z';
